/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * League Of Predictors API Gateway
 * OpenAPI spec version: v1
 */
import { apiClient } from './mutator';
export interface AccessoryActionsDetails {
  sell: ItemActionAvailability;
  merge: ItemActionAvailability;
  equip: ItemActionAvailability;
  unequip: ItemActionAvailability;
  /** @nullable */
  unequipAvailableAt?: string | null;
}

export interface AccessoryCollectionDetails {
  /** @nullable */
  accessories: AccessoryDetails[] | null;
  count: number;
}

export type AccessoryCollectionDetailsResponseContent =
  | AccessoryCollectionDetails
  | undefined;

export interface AccessoryDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  equipmentId?: string | null;
  type: AccessoryType;
  rarity: AccessoryRarity;
  comfortBonus: number;
  styleBonus: number;
  wearResistanceBonus: number;
  luckinessBonus: number;
  isSalesOnMarket: boolean;
  actions?: AccessoryActionsDetails;
  media?: MediaAssetDetails;
}

export type AccessoryDetailsResponseContent = AccessoryDetails | undefined;

export type AccessoryRarity =
  (typeof AccessoryRarity)[keyof typeof AccessoryRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessoryRarity = {
  ordinary: 'ordinary',
  unusual: 'unusual',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export type AccessoryType = (typeof AccessoryType)[keyof typeof AccessoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessoryType = {
  boots: 'boots',
  guards: 'guards',
  gloves: 'gloves',
} as const;

export interface AddEventsToPoolRequest {
  /** @nullable */
  poolId: string | null;
  /** @nullable */
  eventIdentifiers: string[] | null;
}

export interface AdjustWalletBalanceRequest {
  currency: WalletCurrency;
  amount: number;
  /** @nullable */
  comment?: string | null;
}

export interface AuthorizeAuditUserRequest {
  /** @nullable */
  login: string | null;
  /** @nullable */
  password: string | null;
}

export interface AuthorizeUserRequest {
  /** @nullable */
  login: string | null;
  /** @nullable */
  password: string | null;
}

export interface AvatarCatalogDetails {
  /** @nullable */
  formCategories: AvatarFormCategoryDetails[] | null;
  /** @nullable */
  colorCategories: AvatarColorCategoryDetails[] | null;
}

export type AvatarCatalogDetailsResponseContent =
  | AvatarCatalogDetails
  | undefined;

export interface AvatarColorCategoryDetails {
  /** @nullable */
  category: string | null;
  step: number;
  /** @nullable */
  palette: string[] | null;
  /** @nullable */
  default: string | null;
}

export interface AvatarDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  userId: string | null;
  headShape?: HeadShapeForm;
  /** @nullable */
  skinColor?: string | null;
  hairstyle?: HairstyleForm;
  /** @nullable */
  hairColor?: string | null;
  expression?: ExpressionForm;
  glasses?: GlassesForm;
  beard?: BeardForm;
  /** @nullable */
  shirtColor?: string | null;
  /** @nullable */
  avatarImageUrl?: string | null;
}

export interface AvatarDraftDetails {
  draft?: AvatarPreviewRequest;
}

export type AvatarDraftDetailsResponseContent = AvatarDraftDetails | undefined;

export interface AvatarFormCategoryDetails {
  /** @nullable */
  category: string | null;
  step: number;
  /** @nullable */
  options: AvatarFormOptionDetails[] | null;
}

export interface AvatarFormOptionDetails {
  value: number;
  /** @nullable */
  name: string | null;
  /** @nullable */
  imageUrl: string | null;
}

export interface AvatarPreviewRequest {
  headShape?: HeadShapeForm;
  /** @nullable */
  skinColor?: string | null;
  hairstyle?: HairstyleForm;
  /** @nullable */
  hairColor?: string | null;
  expression?: ExpressionForm;
  glasses?: GlassesForm;
  beard?: BeardForm;
  /** @nullable */
  shirtColor?: string | null;
}

export interface AvatarRandomDetails {
  selection: UpdateAvatarRequest;
}

export type AvatarRandomDetailsResponseContent =
  | AvatarRandomDetails
  | undefined;

export interface BanUserRequest {
  /** @nullable */
  banReason: string | null;
}

export type BeardForm = (typeof BeardForm)[keyof typeof BeardForm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BeardForm = {
  none: 'none',
  stubble: 'stubble',
  full: 'full',
  goatee: 'goatee',
  mustache: 'mustache',
  handlebar: 'handlebar',
  soulPatch: 'soulPatch',
  chinStrip: 'chinStrip',
  ducktail: 'ducktail',
  vanDyke: 'vanDyke',
} as const;

export interface ChangePasswordRequest {
  /** @nullable */
  oldPassword: string | null;
  /** @nullable */
  newPassword: string | null;
}

export interface CheckUserAvailabilityRequest {
  /** @nullable */
  login: string | null;
  /** @nullable */
  email: string | null;
}

export interface CodeDetails {
  isSent: boolean;
  /** @nullable */
  nextCodeIssueTime: string | null;
}

export type CodeDetailsResponseContent = CodeDetails | undefined;

export interface CompetitionCollectionDetails {
  /** @nullable */
  competition: CompetitionDetails[] | null;
}

export type CompetitionCollectionDetailsResponseContent =
  | CompetitionCollectionDetails
  | undefined;

export interface CompetitionDetails {
  /** @nullable */
  competitionId: string | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  rang: string | null;
  /** @nullable */
  countryId: string | null;
  country: CountryDetails;
  isFromApi?: boolean;
}

export type CompetitionDetailsResponseContent = CompetitionDetails | undefined;

export interface ConvertRpToTicketsRequest {
  ticketAmount: number;
  /** @nullable */
  operationId: string | null;
}

export interface CountryCollectionDetails {
  /** @nullable */
  countries: CountryDetails[] | null;
}

export type CountryCollectionDetailsResponseContent =
  | CountryCollectionDetails
  | undefined;

export interface CountryDetails {
  /** @nullable */
  countryId: string | null;
  /** @nullable */
  name: string | null;
}

export type CountryDetailsResponseContent = CountryDetails | undefined;

export interface CreateCompetitionRequest {
  /** @nullable */
  name: string | null;
  /** @nullable */
  rang: string | null;
  /** @nullable */
  countryName: string | null;
}

export interface CreateCountryRequest {
  /** @nullable */
  name: string | null;
}

export interface CreateDuelEntryRequest {
  /** @nullable */
  eventPoolId: string | null;
  /** @nullable */
  equipmentId: string | null;
}

export interface CreateDuelModeForecastEventRequest {
  /** @nullable */
  eventId: string | null;
  blueTeamScoreResult: number;
  redTeamScoreResult: number;
}

export interface CreateDuelModeForecastsEventRequest {
  /** @nullable */
  poolId: string | null;
  /** @nullable */
  forecasts: CreateDuelModeForecastEventRequest[] | null;
}

export interface CreateEventPoolRequest {
  mode: EventPoolMode;
  poolDate: string;
}

export interface CreateEventRequest {
  startAtUtc: string;
  status: EventStatus;
  blueTeam: CreateEventTeamRequest;
  redTeam: CreateEventTeamRequest;
  country: CreateCountryRequest;
  competition: CreateCompetitionRequest;
}

export interface CreateEventTeamRequest {
  /** @nullable */
  teamId: string | null;
  winProbability: number;
}

export interface CreateEventsRequest {
  /** @nullable */
  events: CreateEventRequest[] | null;
}

export interface CreateSingleModeForecastEventRequest {
  /** @nullable */
  eventId: string | null;
  blueTeamScoreResult: number;
  redTeamScoreResult: number;
}

export interface CreateSingleModeForecastEventsRequest {
  /** @nullable */
  poolId: string | null;
  /** @nullable */
  forecasts: CreateSingleModeForecastEventRequest[] | null;
  isGiveawayEntry?: boolean;
}

export interface CredentialsDetails {
  /** @nullable */
  jsonWebToken: string | null;
  jsonWebTokenExpiresAt: string;
  /** @nullable */
  refreshToken: string | null;
  refreshTokenExpiresAt?: string;
}

export type CredentialsDetailsResponseContent = CredentialsDetails | undefined;

export interface CrossEquipmentResultDetails {
  /** @nullable */
  createdEquipmentId: string | null;
  createdEquipmentRarity: EquipmentRarity;
  rpSpent: number;
  /** @nullable */
  burnedEquipmentIds: string[] | null;
}

export type CrossEquipmentResultDetailsResponseContent =
  | CrossEquipmentResultDetails
  | undefined;

export interface CrossEquipmentsRequest {
  /** @nullable */
  firstEquipmentId: string | null;
  /** @nullable */
  secondEquipmentId: string | null;
}

export interface DuelGiveawayEntryStatisticDetails {
  goalsScored: number;
  duelsCount: number;
  winsCount: number;
  drawsCount: number;
}

export interface DuelMatchCollectionDetails {
  /** @nullable */
  matches: DuelMatchDetails[] | null;
  count: number;
}

export type DuelMatchCollectionDetailsResponseContent =
  | DuelMatchCollectionDetails
  | undefined;

export interface DuelMatchDetails {
  /** @nullable */
  entryId: string | null;
  /** @nullable */
  eventPoolId: string | null;
  /** @nullable */
  equipmentId: string | null;
  isSettled: boolean;
  isShadowOpponent: boolean;
  stage?: DuelMatchStage;
  opponent?: DuelOpponentDetails;
  result?: DuelMatchResultDetails;
}

export interface DuelMatchResultDetails {
  goalsScored: number;
  goalsConceded: number;
  isWinner: boolean;
  isDraw: boolean;
  playedAt: string;
}

export type DuelMatchStage =
  (typeof DuelMatchStage)[keyof typeof DuelMatchStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DuelMatchStage = {
  waitingForMatching: 'waitingForMatching',
  matched: 'matched',
  noOpponent: 'noOpponent',
  played: 'played',
} as const;

export interface DuelModeStatisticDetails {
  totalDuelsCount: number;
  winsCount: number;
  drawsCount: number;
  lossesCount: number;
  rpWinAmount: number;
  scWinAmount: number;
  winRate: number;
  averageGoalsPerDuel: number;
  averagePointsPerDuel: number;
}

export interface DuelOpponentDetails {
  /** @nullable */
  userId: string | null;
  /** @nullable */
  username?: string | null;
  /** @nullable */
  equipmentId: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  forecasts?: DuelOpponentForecastDetails[] | null;
}

export interface DuelOpponentForecastDetails {
  /** @nullable */
  eventId: string | null;
  blueTeamScorePredict: number;
  redTeamScorePredict: number;
}

export interface EquipmentActionsDetails {
  sell: ItemActionAvailability;
  cross: ItemActionAvailability;
  upgrade: ItemActionAvailability;
  restore: ItemActionAvailability;
  equipAccessory: ItemActionAvailability;
}

export interface EquipmentCollectionDetails {
  /** @nullable */
  equipments: EquipmentDetails[] | null;
  count: number;
}

export type EquipmentCollectionDetailsResponseContent =
  | EquipmentCollectionDetails
  | undefined;

export interface EquipmentDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  userId: string | null;
  rarity: EquipmentRarity;
  level: number;
  comfort: number;
  style: number;
  wearResistance: number;
  luckiness: number;
  cleanness: number;
  durability: number;
  energy: number;
  isSalesOnMarket: boolean;
  isInDuel: boolean;
  actions?: EquipmentActionsDetails;
  repairCost?: EquipmentRepairCostDetails;
  ballMedia?: MediaAssetDetails;
  /** @nullable */
  accessories?: AccessoryDetails[] | null;
  upgradeLevelCost?: EquipmentUpgradeLevelCostDetails;
}

export type EquipmentDetailsResponseContent = EquipmentDetails | undefined;

export type EquipmentRarity =
  (typeof EquipmentRarity)[keyof typeof EquipmentRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EquipmentRarity = {
  ordinary: 'ordinary',
  unusual: 'unusual',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export interface EquipmentRepairCostDetails {
  patchPerDurabilityPoint: number;
  fullRestoreDiscountPercent: number;
  fullRestorePatchCost: number;
}

export interface EquipmentRestoreSettingsCollectionDetails {
  /** @nullable */
  settings: EquipmentRestoreSettingsDetails[] | null;
}

export type EquipmentRestoreSettingsCollectionDetailsResponseContent =
  | EquipmentRestoreSettingsCollectionDetails
  | undefined;

export interface EquipmentRestoreSettingsDetails {
  rarity: EquipmentRarity;
  onePercentPricePatch: number;
  fullRestorePricePatch: number;
  fullRestoreDiscountPercent: number;
}

export type EquipmentRestoreSettingsDetailsResponseContent =
  | EquipmentRestoreSettingsDetails
  | undefined;

export interface EquipmentUpgradeLevelCostDetails {
  nextLevel: number;
  scoreCost: number;
  rpCost: number;
}

export interface EventCollectionDetails {
  /** @nullable */
  events: EventDetails[] | null;
  count: number;
}

export type EventCollectionDetailsResponseContent =
  | EventCollectionDetails
  | undefined;

export interface EventDetails {
  /** @nullable */
  id: string | null;
  startAtUtc: string;
  status: EventStatus;
  blueTeam: EventTeamDetails;
  redTeam: EventTeamDetails;
  blueTeamResultScore: number;
  redTeamResultScore: number;
  blueTeamWinProbability: number;
  redTeamWinProbability: number;
  country: CountryDetails;
  competition: CompetitionDetails;
  membersCount?: number;
  isFromApi?: boolean;
}

export type EventDetailsResponseContent = EventDetails | undefined;

export interface EventForecastCollectionDetails {
  /** @nullable */
  eventForecasts: EventForecastDetails[] | null;
  count: number;
  isGiveawayEntry: boolean;
}

export type EventForecastCollectionDetailsResponseContent =
  | EventForecastCollectionDetails
  | undefined;

export interface EventForecastDetails {
  blueTeamResultScorePredict: number;
  redTeamResultScorePredict: number;
  /** @nullable */
  eventId: string | null;
  isGiveawayEntry: boolean;
}

export interface EventPoolCollectionDetails {
  /** @nullable */
  eventPools: EventPoolDetails[] | null;
  count: number;
}

export type EventPoolCollectionDetailsResponseContent =
  | EventPoolCollectionDetails
  | undefined;

export type EventPoolDay = (typeof EventPoolDay)[keyof typeof EventPoolDay];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventPoolDay = {
  today: 'today',
  tomorrow: 'tomorrow',
  yesterday: 'yesterday',
} as const;

export interface EventPoolDetails {
  /** @nullable */
  id: string | null;
  status: EventPoolStatus;
  mode: EventPoolMode;
  date: string;
  /** @nullable */
  events: EventDetails[] | null;
}

export type EventPoolDetailsResponseContent = EventPoolDetails | undefined;

export type EventPoolMode = (typeof EventPoolMode)[keyof typeof EventPoolMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventPoolMode = {
  singleMode: 'singleMode',
  duelMode: 'duelMode',
  leagueMode: 'leagueMode',
  tournamentMode: 'tournamentMode',
} as const;

export type EventPoolStatus =
  (typeof EventPoolStatus)[keyof typeof EventPoolStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventPoolStatus = {
  opened: 'opened',
  closed: 'closed',
  filled: 'filled',
  calculated: 'calculated',
} as const;

export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventStatus = {
  waiting: 'waiting',
  started: 'started',
  finished: 'finished',
  cancelled: 'cancelled',
} as const;

export interface EventTeamDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  teamName: string | null;
  emblem?: MediaAssetDetails;
  isFromApi?: boolean;
}

export type EventTeamDetailsResponseContent = EventTeamDetails | undefined;

export type ExpressionForm =
  (typeof ExpressionForm)[keyof typeof ExpressionForm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExpressionForm = {
  neutral: 'neutral',
  happy: 'happy',
  serious: 'serious',
  surprised: 'surprised',
  smile: 'smile',
  content: 'content',
  calm: 'calm',
  friendly: 'friendly',
  grin: 'grin',
  laugh: 'laugh',
  cheerful: 'cheerful',
  joyful: 'joyful',
} as const;

export interface ForgotPasswordRequest {
  /** @nullable */
  email: string | null;
  /** @nullable */
  newPassword: string | null;
  /** @nullable */
  verificationCode: string | null;
}

export type Gender = (typeof Gender)[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  none: 'none',
  male: 'male',
  female: 'female',
} as const;

export interface GeneralStatisticDetails {
  level: number;
  experience: number;
  scEarnedForAllTime: number;
  rpEarnedForAllTime: number;
  placeInTheOverallRanking: number;
  totalForecastsCount: number;
  totalForecastWithCorrectScoreCount: number;
  totalForecastWithCorrectWinnerCount: number;
  kpi: number;
  totalDaysInTheGame: number;
  totalPatchBoxesCount: number;
}

export interface GiveawayCountdownDetails {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export type GiveawayKind = (typeof GiveawayKind)[keyof typeof GiveawayKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiveawayKind = {
  dailySingle: 'dailySingle',
  weeklySingle: 'weeklySingle',
  weeklyDuel: 'weeklyDuel',
} as const;

export interface GiveawayLeaderboardEntryDetails {
  /** @nullable */
  userId: string | null;
  /** @nullable */
  username?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  equipmentId?: string | null;
  /** @nullable */
  rank?: number | null;
  score: number;
  isGiveawayEntry: boolean;
  isWinner: boolean;
  rpReward: number;
  scReward: number;
  patchReward: number;
  lootBagReward?: LootBagRarity;
  singleStatistic?: SingleGiveawayEntryStatisticDetails;
  duelStatistic?: DuelGiveawayEntryStatisticDetails;
}

export type GiveawayLeaderboardPeriod =
  (typeof GiveawayLeaderboardPeriod)[keyof typeof GiveawayLeaderboardPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiveawayLeaderboardPeriod = {
  week: 'week',
  allTime: 'allTime',
} as const;

export interface GiveawayPlaceRewardCollectionDetails {
  /** @nullable */
  rules: GiveawayPlaceRewardDetails[] | null;
}

export type GiveawayPlaceRewardCollectionDetailsResponseContent =
  | GiveawayPlaceRewardCollectionDetails
  | undefined;

export interface GiveawayPlaceRewardDetails {
  kind: GiveawayKind;
  place: number;
  rpAmount: number;
  scAmount: number;
}

export type GiveawayPlaceRewardDetailsResponseContent =
  | GiveawayPlaceRewardDetails
  | undefined;

export interface GiveawayResultCollectionDetails {
  /** @nullable */
  results: GiveawayResultSummaryDetails[] | null;
  count: number;
}

export type GiveawayResultCollectionDetailsResponseContent =
  | GiveawayResultCollectionDetails
  | undefined;

export interface GiveawayResultDetails {
  /** @nullable */
  id: string | null;
  kind: GiveawayKind;
  periodStartUtc: string;
  periodEndUtc: string;
  calculatedAtUtc: string;
  participantsCount: number;
  entriesCount: number;
  prizePoolRp: number;
  prizePoolSc: number;
  prizePoolPatch: number;
  prizePoolLootBagCount: number;
  topScore: number;
  /** @nullable */
  leaderboard: GiveawayLeaderboardEntryDetails[] | null;
}

export type GiveawayResultDetailsResponseContent =
  | GiveawayResultDetails
  | undefined;

export interface GiveawayResultSummaryDetails {
  /** @nullable */
  id: string | null;
  kind: GiveawayKind;
  periodStartUtc: string;
  periodEndUtc: string;
  calculatedAtUtc: string;
  participantsCount: number;
  entriesCount: number;
  prizePoolRp: number;
  prizePoolSc: number;
  prizePoolPatch: number;
  prizePoolLootBagCount: number;
  topScore: number;
}

export type GlassesForm = (typeof GlassesForm)[keyof typeof GlassesForm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GlassesForm = {
  none: 'none',
  round: 'round',
  square: 'square',
  sport: 'sport',
  oval: 'oval',
  rectangle: 'rectangle',
  sunglasses: 'sunglasses',
  roundBold: 'roundBold',
  catEye: 'catEye',
} as const;

export interface GrantUserLootBagRequest {
  rarity: LootBagRarity;
}

export interface GrantUserPatchBoxRequest {
  rarity: PatchBoxRarity;
}

export type HairstyleForm = (typeof HairstyleForm)[keyof typeof HairstyleForm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HairstyleForm = {
  bald: 'bald',
  short: 'short',
  loose: 'loose',
  tail: 'tail',
  bun: 'bun',
  curly: 'curly',
  sidePart: 'sidePart',
  topKnot: 'topKnot',
  sideSwept: 'sideSwept',
  updo: 'updo',
  messy: 'messy',
  swept: 'swept',
  bowl: 'bowl',
  long: 'long',
  bob: 'bob',
  bangs: 'bangs',
  wavy: 'wavy',
  afro: 'afro',
  coils: 'coils',
  slick: 'slick',
  pompadour: 'pompadour',
  undercut: 'undercut',
  waves: 'waves',
  sweptBack: 'sweptBack',
  combOver: 'combOver',
  shaggy: 'shaggy',
} as const;

export type HeadShapeForm = (typeof HeadShapeForm)[keyof typeof HeadShapeForm];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeadShapeForm = {
  round: 'round',
  oval: 'oval',
  square: 'square',
  long: 'long',
} as const;

export interface InventoryOperationRpCostDetails {
  rpCost: number;
}

export type InventoryOperationRpCostDetailsResponseContent =
  | InventoryOperationRpCostDetails
  | undefined;

export interface ItemActionAvailability {
  allowed: boolean;
  reason?: ItemActionBlockReason;
  /** @nullable */
  message?: string | null;
}

export type ItemActionBlockReason =
  (typeof ItemActionBlockReason)[keyof typeof ItemActionBlockReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemActionBlockReason = {
  onMarket: 'onMarket',
  inDuel: 'inDuel',
  minLevel: 'minLevel',
  maxLevel: 'maxLevel',
  hasAccessories: 'hasAccessories',
  lastEquipment: 'lastEquipment',
  noPartner: 'noPartner',
  fullDurability: 'fullDurability',
  slotsFull: 'slotsFull',
  equipped: 'equipped',
  notEquipped: 'notEquipped',
  maxRarity: 'maxRarity',
  equipmentOnMarket: 'equipmentOnMarket',
  equipmentInDuel: 'equipmentInDuel',
  cooldown: 'cooldown',
  notConfigured: 'notConfigured',
} as const;

export type Language = (typeof Language)[keyof typeof Language];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Language = {
  english: 'english',
  russian: 'russian',
} as const;

export type LootBagRarity = (typeof LootBagRarity)[keyof typeof LootBagRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LootBagRarity = {
  ordinary: 'ordinary',
  unusual: 'unusual',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export type LootBagSource = (typeof LootBagSource)[keyof typeof LootBagSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LootBagSource = {
  single: 'single',
  duel: 'duel',
  patchBox: 'patchBox',
  admin: 'admin',
} as const;

export interface LootBagTicketDropRuleCollectionDetails {
  /** @nullable */
  rules: LootBagTicketDropRuleDetails[] | null;
}

export type LootBagTicketDropRuleCollectionDetailsResponseContent =
  | LootBagTicketDropRuleCollectionDetails
  | undefined;

export interface LootBagTicketDropRuleDetails {
  rarity: LootBagRarity;
  chancePercent: number;
}

export type LootBagTicketDropRuleDetailsResponseContent =
  | LootBagTicketDropRuleDetails
  | undefined;

export interface MarketListingCollectionDetails {
  /** @nullable */
  listings: MarketListingDetails[] | null;
}

export type MarketListingCollectionDetailsResponseContent =
  | MarketListingCollectionDetails
  | undefined;

export interface MarketListingDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  sellerUserId: string | null;
  itemType: MarketListingItemType;
  priceRp: number;
  createdAt: string;
  /** @nullable */
  itemId: string | null;
  /** @nullable */
  assetNumber?: number | null;
  ballMedia?: MediaAssetDetails;
  media?: MediaAssetDetails;
  /** @nullable */
  equipmentLevel?: number | null;
  /** @nullable */
  equipmentCleanness?: number | null;
  equipmentRarity?: EquipmentRarity;
  accessoryRarity?: AccessoryRarity;
  accessoryType?: AccessoryType;
}

export type MarketListingDetailsResponseContent =
  | MarketListingDetails
  | undefined;

export type MarketListingItemType =
  (typeof MarketListingItemType)[keyof typeof MarketListingItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketListingItemType = {
  equipment: 'equipment',
  accessory: 'accessory',
} as const;

export type MatchMode = (typeof MatchMode)[keyof typeof MatchMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MatchMode = {
  single: 'single',
  duel: 'duel',
} as const;

export interface MatchResultDetails {
  mode: MatchMode;
  forecastCount: number;
  forecastWithCorrectScoreCount: number;
  forecastWithCorrectWinnerCount: number;
  /** @nullable */
  opponentUserId?: string | null;
  /** @nullable */
  isWinner?: boolean | null;
  /** @nullable */
  goalsScored?: number | null;
  /** @nullable */
  goalsConceded?: number | null;
  /** @nullable */
  equipmentId?: string | null;
  equipment?: EquipmentDetails;
  rpReward: number;
  scReward: number;
  experienceReward: number;
  /** @nullable */
  patchBoxIds: string[] | null;
  /** @nullable */
  lootBagRarities: LootBagRarity[] | null;
}

export interface MediaAssetDetails {
  /** @nullable */
  id: string | null;
  fileType: MediaFileType;
  mimeType: MediaMimeType;
  fileSizeBytes: number;
  /** @nullable */
  url: string | null;
}

export type MediaAssetDetailsResponseContent = MediaAssetDetails | undefined;

export interface MediaFileDetails {
  /** @nullable */
  url: string | null;
  /** @nullable */
  contentType: string | null;
  fileSizeBytes: number;
  expiresAtUtc: string;
}

export type MediaFileDetailsResponseContent = MediaFileDetails | undefined;

export type MediaFileType = (typeof MediaFileType)[keyof typeof MediaFileType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaFileType = {
  image: 'image',
  document: 'document',
} as const;

export type MediaFolder = (typeof MediaFolder)[keyof typeof MediaFolder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaFolder = {
  inventory: 'inventory',
  profile: 'profile',
  matchmaking: 'matchmaking',
} as const;

export type MediaMimeType = (typeof MediaMimeType)[keyof typeof MediaMimeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaMimeType = {
  imagePng: 'imagePng',
  imageJpeg: 'imageJpeg',
  imageWebp: 'imageWebp',
  imageSvgXml: 'imageSvgXml',
  applicationPdf: 'applicationPdf',
} as const;

export type MediaOwnerDomain =
  (typeof MediaOwnerDomain)[keyof typeof MediaOwnerDomain];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaOwnerDomain = {
  inventory: 'inventory',
  profile: 'profile',
  matchmaking: 'matchmaking',
} as const;

export type MediaOwnerType =
  (typeof MediaOwnerType)[keyof typeof MediaOwnerType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaOwnerType = {
  equipmentRarity: 'equipmentRarity',
  accessoryRarity: 'accessoryRarity',
  equipment: 'equipment',
  accessory: 'accessory',
  teamEmblem: 'teamEmblem',
  equipmentSourceSvg: 'equipmentSourceSvg',
  accessorySourceSvg: 'accessorySourceSvg',
  avatar: 'avatar',
  avatarSourceSvg: 'avatarSourceSvg',
} as const;

export interface MergeAccessoriesRequest {
  /** @nullable */
  firstAccessoryId: string | null;
  /** @nullable */
  secondAccessoryId: string | null;
}

export interface MergeAccessoriesResultDetails {
  isSuccess: boolean;
  rpSpent: number;
  /** @nullable */
  burnedAccessoryIds: string[] | null;
  /** @nullable */
  createdAccessoryId?: string | null;
  createdAccessoryRarity?: AccessoryRarity;
  createdAccessoryType?: AccessoryType;
}

export type MergeAccessoriesResultDetailsResponseContent =
  | MergeAccessoriesResultDetails
  | undefined;

export interface NotificationCollectionDetails {
  /** @nullable */
  notifications: NotificationDetails[] | null;
  count: number;
}

export type NotificationCollectionDetailsResponseContent =
  | NotificationCollectionDetails
  | undefined;

export interface NotificationDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  userId: string | null;
  type: NotificationType;
  /** @nullable */
  title: string | null;
  /** @nullable */
  body: string | null;
  createdAt: string;
  /** @nullable */
  sourceEventId: string | null;
  matchResult?: MatchResultDetails;
}

export type NotificationDetailsResponseContent =
  | NotificationDetails
  | undefined;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationType = {
  matchResult: 'matchResult',
  welcome: 'welcome',
} as const;

export interface OnboardingStatusDetails {
  isOnboardingCompleted: boolean;
}

export type OnboardingStatusDetailsResponseContent =
  | OnboardingStatusDetails
  | undefined;

export interface OpenLootBagResultDetails {
  /** @nullable */
  userLootBagId: string | null;
  rarity: LootBagRarity;
  scSpentForEarlyOpen: number;
  /** @nullable */
  createdEquipmentIds: string[] | null;
  /** @nullable */
  createdAccessoryIds: string[] | null;
  ticketAwarded: number;
}

export type OpenLootBagResultDetailsResponseContent =
  | OpenLootBagResultDetails
  | undefined;

export interface OpenPatchBoxResultDetails {
  /** @nullable */
  userPatchBoxId: string | null;
  patchAwarded: number;
  rpAwarded: number;
  scSpentForEarlyOpen: number;
  lootBagAwarded: boolean;
  lootBagRarity?: LootBagRarity;
  /** @nullable */
  createdUserLootBagId?: string | null;
}

export type OpenPatchBoxResultDetailsResponseContent =
  | OpenPatchBoxResultDetails
  | undefined;

export interface PatchBoxCollectionDetails {
  /** @nullable */
  patchBoxes: PatchBoxDetails[] | null;
  count: number;
}

export type PatchBoxCollectionDetailsResponseContent =
  | PatchBoxCollectionDetails
  | undefined;

export interface PatchBoxDetails {
  /** @nullable */
  id: string | null;
  rarity: PatchBoxRarity;
  patchMinCount: number;
  patchMaxCount: number;
}

export type PatchBoxDetailsResponseContent = PatchBoxDetails | undefined;

export type PatchBoxRarity =
  (typeof PatchBoxRarity)[keyof typeof PatchBoxRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBoxRarity = {
  ordinary: 'ordinary',
  unusual: 'unusual',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export interface ProfileCollectionDetails {
  /** @nullable */
  profiles: ProfileDetails[] | null;
  count: number;
}

export type ProfileCollectionDetailsResponseContent =
  | ProfileCollectionDetails
  | undefined;

export interface ProfileDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  username: string | null;
  /** @nullable */
  email?: string | null;
  age: number;
  gender: Gender;
  language: Language;
  isOnboardingCompleted: boolean;
  isAdmin?: boolean;
  isBanned: boolean;
  /** @nullable */
  referralCode?: string | null;
  avatar: AvatarDetails;
}

export interface ProfileDetailsById {
  /** @nullable */
  id: string | null;
  /** @nullable */
  username: string | null;
  /** @nullable */
  email?: string | null;
  age: number;
  gender: Gender;
  language: Language;
  isOnboardingCompleted: boolean;
  isAdmin?: boolean;
  isBanned: boolean;
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  wallet: WalletDetails;
}

export type ProfileDetailsByIdResponseContent = ProfileDetailsById | undefined;

export type ProfileDetailsResponseContent = ProfileDetails | undefined;

export interface ReferralCurrencyAmountDetails {
  /** @nullable */
  currency: string | null;
  amount: number;
}

export interface ReferralDetails {
  /** @nullable */
  userId: string | null;
  /** @nullable */
  referralCode: string | null;
  isReferralCodeActive: boolean;
  totalReferrals: number;
  activatedReferrals: number;
  /** @nullable */
  accruedRewards: ReferralCurrencyAmountDetails[] | null;
  /** @nullable */
  referrals: ReferralEntryDetails[] | null;
}

export type ReferralDetailsResponseContent = ReferralDetails | undefined;

export interface ReferralEntryDetails {
  /** @nullable */
  name: string | null;
  /** @nullable */
  rewards: ReferralRewardDetails[] | null;
}

export interface ReferralRewardDetails {
  rewardKey: ReferralRewardKey;
  /** @nullable */
  currency: string | null;
  amount: number;
}

export type ReferralRewardKey =
  (typeof ReferralRewardKey)[keyof typeof ReferralRewardKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferralRewardKey = {
  activationBonus: 'activationBonus',
  firstMonthActivityBonus: 'firstMonthActivityBonus',
  revenueShare: 'revenueShare',
} as const;

export interface RefreshJsonWebTokenRequest {
  /** @nullable */
  accessToken: string | null;
  /** @nullable */
  refreshToken: string | null;
}

export interface RegisterUserRequest {
  /** @nullable */
  login: string | null;
  /** @nullable */
  password: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  verificationCode: string | null;
  /** @nullable */
  referralCode?: string | null;
}

export interface RestoreAccountRequest {
  /** @nullable */
  email: string | null;
  /** @nullable */
  password: string | null;
  /** @nullable */
  verificationCode: string | null;
}

export interface RestoreEquipmentDurabilityRequest {
  durability: number;
}

export interface RestoreEquipmentDurabilityResultDetails {
  /** @nullable */
  equipmentId: string | null;
  previousDurability: number;
  currentDurability: number;
  patchSpent: number;
}

export type RestoreEquipmentDurabilityResultDetailsResponseContent =
  | RestoreEquipmentDurabilityResultDetails
  | undefined;

export interface RpToTicketConversionDetails {
  isApplied: boolean;
  rpSpent: number;
  ticketsReceived: number;
  rpBalance: number;
  ticketBalance: number;
}

export type RpToTicketConversionDetailsResponseContent =
  | RpToTicketConversionDetails
  | undefined;

export interface SellMarketItemRequest {
  priceRp: number;
}

export interface SendVerificationCodeRequest {
  /** @nullable */
  email: string | null;
  codeType: VerificationCodeType;
}

export interface SingleGiveawayEntryStatisticDetails {
  /** @nullable */
  ticketRank?: number | null;
  ticketScore: number;
  ticketCount: number;
}

export interface SingleGiveawayLeaderboardDetails {
  serverTimeUtc: string;
  period: GiveawayLeaderboardPeriod;
  /** @nullable */
  periodStartUtc?: string | null;
  /** @nullable */
  periodEndUtc?: string | null;
  countdown?: GiveawayCountdownDetails;
  /** @nullable */
  prizePoolRp?: number | null;
  /** @nullable */
  prizePoolSc?: number | null;
  totalTickets: number;
  totalParticipantsCount: number;
  /** @nullable */
  entries: SingleGiveawayLeaderboardEntryDetails[] | null;
  count: number;
  currentUserEntry?: SingleGiveawayLeaderboardEntryDetails;
}

export type SingleGiveawayLeaderboardDetailsResponseContent =
  | SingleGiveawayLeaderboardDetails
  | undefined;

export interface SingleGiveawayLeaderboardEntryDetails {
  /** @nullable */
  userId: string | null;
  /** @nullable */
  username?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  rank: number;
  score: number;
  isGiveawayEntry: boolean;
  ticketCount: number;
}

export interface SingleModeStatisticDetails {
  placeInTopByWonBets: number;
  betsCount: number;
  winsCount: number;
  lossesCount: number;
  rpWinAmount: number;
  scWinAmount: number;
  patchBoxesCount: number;
  forecastCount: number;
  forecastWithCorrectWinnerCount: number;
  forecastWithCorrectScoreCount: number;
  incorrectForecastCount: number;
}

export interface StatisticDetails {
  generalStatistic: GeneralStatisticDetails;
  singleModeStatistic: SingleModeStatisticDetails;
  duelModeStatistic: DuelModeStatisticDetails;
}

export type StatisticDetailsResponseContent = StatisticDetails | undefined;

export interface TeamCollectionDetails {
  /** @nullable */
  teams: EventTeamDetails[] | null;
  count: number;
}

export type TeamCollectionDetailsResponseContent =
  | TeamCollectionDetails
  | undefined;

export interface TicketConversionRateDetails {
  rpPerTicket: number;
}

export type TicketConversionRateDetailsResponseContent =
  | TicketConversionRateDetails
  | undefined;

export type TransactionType =
  (typeof TransactionType)[keyof typeof TransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionType = {
  singlePoolReward: 'singlePoolReward',
  singlePoolRewardRevert: 'singlePoolRewardRevert',
  duelReward: 'duelReward',
  duelRewardRevert: 'duelRewardRevert',
  patchBoxReward: 'patchBoxReward',
  patchBoxRewardRevert: 'patchBoxRewardRevert',
  patchBoxEarlyOpenFee: 'patchBoxEarlyOpenFee',
  patchBoxEarlyOpenFeeRefund: 'patchBoxEarlyOpenFeeRefund',
  marketListingFee: 'marketListingFee',
  marketListingFeeRefund: 'marketListingFeeRefund',
  marketPurchase: 'marketPurchase',
  marketPurchaseRefund: 'marketPurchaseRefund',
  marketSaleIncome: 'marketSaleIncome',
  marketSaleIncomeRevert: 'marketSaleIncomeRevert',
  accessoryEquipFee: 'accessoryEquipFee',
  accessoryEquipFeeRefund: 'accessoryEquipFeeRefund',
  accessoryMergeFee: 'accessoryMergeFee',
  accessoryMergeFeeRefund: 'accessoryMergeFeeRefund',
  equipmentCrossFee: 'equipmentCrossFee',
  equipmentCrossFeeRefund: 'equipmentCrossFeeRefund',
  equipmentLevelUpgradeFee: 'equipmentLevelUpgradeFee',
  equipmentLevelUpgradeFeeRefund: 'equipmentLevelUpgradeFeeRefund',
  weeklyDuelGiveawayReward: 'weeklyDuelGiveawayReward',
  weeklyDuelGiveawayRewardRevert: 'weeklyDuelGiveawayRewardRevert',
  singlePoolGiveawayEntryFee: 'singlePoolGiveawayEntryFee',
  singlePoolGiveawayEntryFeeRefund: 'singlePoolGiveawayEntryFeeRefund',
  weeklySingleGiveawayReward: 'weeklySingleGiveawayReward',
  weeklySingleGiveawayRewardRevert: 'weeklySingleGiveawayRewardRevert',
  dailySingleGiveawayReward: 'dailySingleGiveawayReward',
  dailySingleGiveawayRewardRevert: 'dailySingleGiveawayRewardRevert',
  equipmentDurabilityRestoreFee: 'equipmentDurabilityRestoreFee',
  equipmentDurabilityRestoreFeeRefund: 'equipmentDurabilityRestoreFeeRefund',
  lootBagEarlyOpenFee: 'lootBagEarlyOpenFee',
  lootBagEarlyOpenFeeRefund: 'lootBagEarlyOpenFeeRefund',
  rpToTicketConvertion: 'rpToTicketConvertion',
  lootBagTicketReward: 'lootBagTicketReward',
  lootBagTicketRewardRevert: 'lootBagTicketRewardRevert',
  manualAdjustment: 'manualAdjustment',
} as const;

export interface UnbanUserRequest {
  [key: string]: unknown;
}

export interface UnreadNotificationStatusDetails {
  readonly hasUnread?: boolean;
  unreadCount: number;
}

export type UnreadNotificationStatusDetailsResponseContent =
  | UnreadNotificationStatusDetails
  | undefined;

export interface UpdateAgeRequest {
  age: number;
}

export interface UpdateAvatarRequest {
  headShape: HeadShapeForm;
  /** @nullable */
  skinColor: string | null;
  hairstyle: HairstyleForm;
  /** @nullable */
  hairColor: string | null;
  expression: ExpressionForm;
  glasses: GlassesForm;
  beard: BeardForm;
  /** @nullable */
  shirtColor: string | null;
}

export interface UpdateCompetitionRequest {
  /** @nullable */
  name: string | null;
  /** @nullable */
  rang: string | null;
  /** @nullable */
  countryName: string | null;
}

export interface UpdateCountryRequest {
  /** @nullable */
  name: string | null;
}

export interface UpdateEquipmentRestoreSettingsRequest {
  onePercentPricePatch: number;
  fullRestorePricePatch: number;
}

export interface UpdateEventPoolRequest {
  status: EventPoolStatus;
  mode: EventPoolMode;
}

export interface UpdateEventRequest {
  startAtUtc: string;
  status: EventStatus;
  blueTeam: UpdateEventTeamRequest;
  redTeam: UpdateEventTeamRequest;
  country: UpdateCountryRequest;
  competition: UpdateCompetitionRequest;
}

export interface UpdateEventTeamRequest {
  /** @nullable */
  teamId: string | null;
  /** @nullable */
  resultScore?: number | null;
  winProbability: number;
}

export interface UpdateGenderRequest {
  gender: Gender;
}

export interface UpdateGiveawayPlaceRewardRequest {
  rpAmount: number;
  scAmount: number;
}

export interface UpdateLanguageRequest {
  language: Language;
}

export interface UpdateLootBagTicketDropRuleRequest {
  chancePercent: number;
}

export interface UpdateUsernameRequest {
  /** @nullable */
  username: string | null;
}

export interface UpgradeEquipmentLevelResultDetails {
  /** @nullable */
  equipmentId: string | null;
  previousLevel: number;
  currentLevel: number;
  scoreSpent: number;
  rpSpent: number;
}

export type UpgradeEquipmentLevelResultDetailsResponseContent =
  | UpgradeEquipmentLevelResultDetails
  | undefined;

export interface UserAvailabilityDetails {
  isLoginAvailable?: boolean;
  isEmailAvailable?: boolean;
}

export type UserAvailabilityDetailsResponseContent =
  | UserAvailabilityDetails
  | undefined;

export interface UserLootBagCollectionDetails {
  /** @nullable */
  userLootBags: UserLootBagDetails[] | null;
  count: number;
}

export type UserLootBagCollectionDetailsResponseContent =
  | UserLootBagCollectionDetails
  | undefined;

export interface UserLootBagDetails {
  /** @nullable */
  id: string | null;
  /** @nullable */
  userId: string | null;
  rarity: LootBagRarity;
  source: LootBagSource;
  /** @nullable */
  readyToOpenAt: string | null;
  isOpened: boolean;
  /** @nullable */
  openCostInSc?: number | null;
  createdAt: string;
}

export type UserLootBagDetailsResponseContent = UserLootBagDetails | undefined;

export interface UserPatchBoxCollectionDetails {
  /** @nullable */
  userPatchBoxes: UserPatchBoxDetails[] | null;
  count: number;
}

export type UserPatchBoxCollectionDetailsResponseContent =
  | UserPatchBoxCollectionDetails
  | undefined;

export interface UserPatchBoxDetails {
  /** @nullable */
  id: string | null;
  openingDuration: string;
  /** @nullable */
  readyToOpenAt: string | null;
  isOpened: boolean;
  /** @nullable */
  openCostInSc?: number | null;
  /** @nullable */
  userId: string | null;
  /** @nullable */
  patchBoxId: string | null;
  patchBox: PatchBoxDetails;
}

export type UserPatchBoxDetailsResponseContent =
  | UserPatchBoxDetails
  | undefined;

export type VerificationCodeType =
  (typeof VerificationCodeType)[keyof typeof VerificationCodeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerificationCodeType = {
  signIn: 'signIn',
  signUp: 'signUp',
  changePassword: 'changePassword',
  forgotPassword: 'forgotPassword',
  restoreAccount: 'restoreAccount',
} as const;

export type WalletCurrency =
  (typeof WalletCurrency)[keyof typeof WalletCurrency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WalletCurrency = {
  rp: 'rp',
  score: 'score',
  patch: 'patch',
  ticket: 'ticket',
} as const;

export interface WalletDetails {
  rpAmount: number;
  scoreAmount: number;
  patchAmount: number;
  ticketAmount: number;
}

export type WalletDetailsResponseContent = WalletDetails | undefined;

export interface WalletTransactionCollectionDetails {
  /** @nullable */
  transactions: WalletTransactionDetails[] | null;
  count: number;
}

export type WalletTransactionCollectionDetailsResponseContent =
  | WalletTransactionCollectionDetails
  | undefined;

export interface WalletTransactionDetails {
  /** @nullable */
  id: string | null;
  transactionType: TransactionType;
  rpDelta: number;
  scoreDelta: number;
  patchDelta: number;
  ticketDelta: number;
  /** @nullable */
  relatedEntityId: string | null;
  /** @nullable */
  comment?: string | null;
  createdAt: string;
}

export type GetApiV1AvatarPreviewParams = {
  HeadShape?: HeadShapeForm;
  SkinColor?: string;
  Hairstyle?: HairstyleForm;
  HairColor?: string;
  Expression?: ExpressionForm;
  Glasses?: GlassesForm;
  Beard?: BeardForm;
  ShirtColor?: string;
};

export type GetApiV1CompetitionCollectionCountryIdParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1CompetitionCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1CountryCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type PostApiV1EditorPoolCloseSingleParams = {
  id?: string;
};

export type DeleteApiV1EditorPoolRemoveEventParams = {
  eventId?: string;
  poolId?: string;
};

export type GetApiV1EditorGiveawayPlaceRewardsParams = {
  kind?: GiveawayKind;
};

export type PostApiV1EditorInventoryEquipmentBody = {
  File: Blob;
  TargetUserId: string;
  Level: number;
  Rarity: EquipmentRarity;
  Comfort: number;
  Style: number;
  WearResistance: number;
  Luckiness: number;
  Cleanness: number;
  Durability: number;
  Energy: number;
};

export type PostApiV1EditorInventoryAccessoryBody = {
  File: Blob;
  EquipmentId: string;
  Type: AccessoryType;
  Rarity: AccessoryRarity;
  ComfortBonus: number;
  StyleBonus: number;
  WearResistanceBonus: number;
  LuckinessBonus: number;
};

export type PostApiV1EditorMediaUploadBody = {
  File: Blob;
  Folder: MediaFolder;
  OwnerDomain: MediaOwnerDomain;
  OwnerType: MediaOwnerType;
  OwnerKey: string;
};

export type PostApiV1EditorTeamBody = {
  Emblem?: Blob;
  TeamName: string;
};

export type PatchApiV1EditorTeamIdBody = {
  Emblem?: Blob;
  TeamName: string;
};

export type GetApiV1EventPoolFilterParams = {
  Mode: EventPoolMode;
  PoolDay?: EventPoolDay;
  DateTime?: string;
};

export type GetApiV1EventPoolCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  mode?: EventPoolMode;
};

export type GetApiV1EventPoolDuelMatchesParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1EventCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  date?: string;
};

export type GetApiV1ForecastSingleParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  eventPoolId?: string;
};

export type GetApiV1ForecastDuelParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  eventPoolId?: string;
};

export type GetApiV1GiveawaySingleLeaderboardParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  period?: GiveawayLeaderboardPeriod;
  fromUtc?: string;
  toUtc?: string;
  ticketOnly?: boolean;
};

export type GetApiV1GiveawayCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  kind?: GiveawayKind;
  fromUtc?: string;
  toUtc?: string;
};

export type GetApiV1InventoryCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1InventoryFilterParams = {
  rarity?: PatchBoxRarity;
};

export type GetApiV1InventoryOwnPatchBoxesCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  isOpened?: boolean;
  rarity?: PatchBoxRarity;
};

export type PostApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpenParams = {
  openImmediately?: boolean;
};

export type GetApiV1InventoryOwnLootBagsCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  isOpened?: boolean;
  rarity?: LootBagRarity;
};

export type PostApiV1InventoryOwnLootBagsUserLootBagIdOpenParams = {
  openImmediately?: boolean;
};

export type GetApiV1InventoryOwnEquipmentCollectionParams = {
  Rarity?: EquipmentRarity;
  CrossWithEquipmentId?: string;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1InventoryOwnAccessoriesCollectionParams = {
  Rarity?: AccessoryRarity;
  MergeWithAccessoryId?: string;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1InventoryEquipmentCrossCostParams = {
  firstEquipmentId?: string;
  secondEquipmentId?: string;
};

export type GetApiV1InventoryAccessoriesMergeCostParams = {
  firstAccessoryId?: string;
  secondAccessoryId?: string;
};

export type GetApiV1InventoryMarketListingsParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  itemType?: MarketListingItemType;
};

export type GetApiV1NotificationCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  type?: NotificationType;
};

export type GetApiV1TeamCollectionParams = {
  TeamName?: string;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
};

export type GetApiV1UserCollectionParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  gender?: Gender;
  language?: Language;
  isOnboardingCompleted?: boolean;
};

export type GetApiV1UserWalletTransactionsParams = {
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  Skip?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  Take?: number;
  OrderByDescending?: boolean;
  currency?: WalletCurrency;
  dateFrom?: string;
  dateTo?: string;
};

export const getLeagueOfPredictorsAPIGateway = () => {
  /**
   * Marks the user account for deletion. The account will be deleted in 30 days. Once marked, the account becomes inaccessible.
   * @summary Marks account for deletion
   */
  const patchApiV1AccountDeletionMark = () => {
    return apiClient<void>({
      url: `/api/v1/account/deletion/mark`,
      method: 'PATCH',
    });
  };

  /**
   * Removes the deletion mark. The account becomes accessible again.
   * @summary Removes scheduled deletion mark
   */
  const patchApiV1AccountDeletionUnmark = () => {
    return apiClient<void>({
      url: `/api/v1/account/deletion/unmark`,
      method: 'PATCH',
    });
  };

  /**
   * Changes the current username to the one provided by the user
   * @summary Updates username
   */
  const patchApiV1AccountUsername = (
    updateUsernameRequest: UpdateUsernameRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/account/username`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUsernameRequest,
    });
  };

  /**
   * Updates all current avatar components with those provided by the user
   * @summary Updates user avatar
   */
  const patchApiV1AccountAvatar = (
    updateAvatarRequest: UpdateAvatarRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/account/avatar`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateAvatarRequest,
    });
  };

  /**
   * Updates age only
   * @summary Updates user age
   */
  const patchApiV1AccountAge = (updateAgeRequest: UpdateAgeRequest) => {
    return apiClient<void>({
      url: `/api/v1/account/age`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateAgeRequest,
    });
  };

  /**
   * Updates gender only
   * @summary Updates user gender
   */
  const patchApiV1AccountGender = (
    updateGenderRequest: UpdateGenderRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/account/gender`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateGenderRequest,
    });
  };

  /**
   * Updates language only
   * @summary Updates user language
   */
  const patchApiV1AccountLanguage = (
    updateLanguageRequest: UpdateLanguageRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/account/language`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateLanguageRequest,
    });
  };

  /**
   * Returns true if onboarding is already completed
   * @summary Gets onboarding status
   */
  const getApiV1AccountOnboardingStatus = () => {
    return apiClient<OnboardingStatusDetailsResponseContent>({
      url: `/api/v1/account/onboarding/status`,
      method: 'GET',
    });
  };

  /**
   * Marks onboarding as completed for the current user
   * @summary Completes onboarding
   */
  const patchApiV1AccountOnboardingComplete = () => {
    return apiClient<void>({
      url: `/api/v1/account/onboarding/complete`,
      method: 'PATCH',
    });
  };

  /**
   * Authorizes user as an admin with all required roles
   * @summary Authorizes user as admin
   */
  const postApiV1AuthAuditAuthorize = (
    authorizeAuditUserRequest: AuthorizeAuditUserRequest,
  ) => {
    return apiClient<CredentialsDetailsResponseContent>({
      url: `/api/v1/auth/audit/authorize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authorizeAuditUserRequest,
    });
  };

  /**
   * Authorizes a user
   * @summary Authorizes user
   */
  const postApiV1AuthAuthorize = (
    authorizeUserRequest: AuthorizeUserRequest,
  ) => {
    return apiClient<CredentialsDetailsResponseContent>({
      url: `/api/v1/auth/authorize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authorizeUserRequest,
    });
  };

  /**
   * Registers a user
   * @summary Registers user
   */
  const postApiV1AuthRegister = (registerUserRequest: RegisterUserRequest) => {
    return apiClient<CredentialsDetailsResponseContent>({
      url: `/api/v1/auth/register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: registerUserRequest,
    });
  };

  /**
   * Checks whether login and email are free for registration
   * @summary Checks login/email availability
   */
  const postApiV1AuthCheckAvailability = (
    checkUserAvailabilityRequest: CheckUserAvailabilityRequest,
  ) => {
    return apiClient<UserAvailabilityDetailsResponseContent>({
      url: `/api/v1/auth/check-availability`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkUserAvailabilityRequest,
    });
  };

  /**
   * Sends verification code to email
   * @summary Sends verification code
   */
  const postApiV1AuthCode = (
    sendVerificationCodeRequest: SendVerificationCodeRequest,
  ) => {
    return apiClient<CodeDetailsResponseContent>({
      url: `/api/v1/auth/code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendVerificationCodeRequest,
    });
  };

  /**
   * Resets user password by verification code sent to email
   * @summary Resets forgotten password
   */
  const postApiV1AuthForgotPassword = (
    forgotPasswordRequest: ForgotPasswordRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/auth/forgot-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordRequest,
    });
  };

  /**
   * Changes password for authenticated user with old password verification
   * @summary Changes user password
   */
  const patchApiV1AuthPassword = (
    changePasswordRequest: ChangePasswordRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/auth/password`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: changePasswordRequest,
    });
  };

  /**
   * Restores an account marked for deletion or soft-deleted by verification code and current password
   * @summary Restores deleted account
   */
  const postApiV1AuthRestoreAccount = (
    restoreAccountRequest: RestoreAccountRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/auth/restore-account`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: restoreAccountRequest,
    });
  };

  /**
   * Generates a new JWT if the provided refresh token is valid
   * @summary Generates a new JSON Web Token
   */
  const postApiV1AuthRefresh = (
    refreshJsonWebTokenRequest: RefreshJsonWebTokenRequest,
  ) => {
    return apiClient<CredentialsDetailsResponseContent>({
      url: `/api/v1/auth/refresh`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: refreshJsonWebTokenRequest,
    });
  };

  /**
   * Returns the form categories (each option as a cached preview-image URL) and the colour palettes used to build a user avatar
   * @summary Retrieves the avatar builder catalog
   */
  const getApiV1AvatarCatalog = () => {
    return apiClient<AvatarCatalogDetailsResponseContent>({
      url: `/api/v1/avatar/catalog`,
      method: 'GET',
    });
  };

  /**
   * Returns a PNG of a full default avatar with the given option applied. Static and immutable — cache aggressively
   * @summary Retrieves a catalog option preview image
   */
  const getApiV1AvatarCatalogImageCategoryValue = (
    category: string,
    value: number,
  ) => {
    return apiClient<Blob>({
      url: `/api/v1/avatar/catalog/image/${category}/${value}`,
      method: 'GET',
      responseType: 'blob',
    });
  };

  /**
   * Returns a PNG of the (possibly partial) avatar selection for the step-by-step builder, rendered on demand and cached by recipe — not stored
   * @summary Renders a live avatar preview
   */
  const getApiV1AvatarPreview = (params?: GetApiV1AvatarPreviewParams) => {
    return apiClient<Blob>({
      url: `/api/v1/avatar/preview`,
      method: 'GET',
      params,
      responseType: 'blob',
    });
  };

  /**
   * Rolls a complete random-but-valid avatar recipe and returns it together with a preview URL. Confirm it via PATCH /api/v1/account/avatar
   * @summary Suggests a random avatar
   */
  const getApiV1AvatarRandom = () => {
    return apiClient<AvatarRandomDetailsResponseContent>({
      url: `/api/v1/avatar/random`,
      method: 'GET',
    });
  };

  /**
   * Returns the user's in-progress avatar selection so the builder can be restored across sessions (null if none saved)
   * @summary Retrieves the saved avatar draft
   */
  const getApiV1AvatarDraft = () => {
    return apiClient<AvatarDraftDetailsResponseContent>({
      url: `/api/v1/avatar/draft`,
      method: 'GET',
    });
  };

  /**
   * Persists the user's in-progress avatar selection so it survives leaving and returning to the builder
   * @summary Saves the avatar draft
   */
  const putApiV1AvatarDraft = (avatarPreviewRequest: AvatarPreviewRequest) => {
    return apiClient<void>({
      url: `/api/v1/avatar/draft`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: avatarPreviewRequest,
    });
  };

  /**
   * Retrieves an competition by its identifier
   * @summary Retrieves an existing competition
   */
  const getApiV1CompetitionId = (id: string) => {
    return apiClient<CompetitionDetailsResponseContent>({
      url: `/api/v1/competition/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves an competition by country identifier
   * @summary Retrieves an existing competition
   */
  const getApiV1CompetitionCollectionCountryId = (
    countryId: string,
    params?: GetApiV1CompetitionCollectionCountryIdParams,
  ) => {
    return apiClient<CompetitionDetailsResponseContent>({
      url: `/api/v1/competition/collection/${countryId}`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves competitions with pagination
   * @summary Retrieves existing competitions
   */
  const getApiV1CompetitionCollection = (
    params?: GetApiV1CompetitionCollectionParams,
  ) => {
    return apiClient<CompetitionCollectionDetailsResponseContent>({
      url: `/api/v1/competition/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves an country by its identifier
   * @summary Retrieves an existing country
   */
  const getApiV1CountryId = (id: string) => {
    return apiClient<CountryDetailsResponseContent>({
      url: `/api/v1/country/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves countries with pagination
   * @summary Retrieves existing countries
   */
  const getApiV1CountryCollection = (
    params?: GetApiV1CountryCollectionParams,
  ) => {
    return apiClient<CountryCollectionDetailsResponseContent>({
      url: `/api/v1/country/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Creates a new competition
   * @summary Creates a new competition
   */
  const postApiV1EditorCompetition = (
    createCompetitionRequest: CreateCompetitionRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/competition`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCompetitionRequest,
    });
  };

  /**
   * Updates an existing competition
   * @summary Updates an existing competition
   */
  const patchApiV1EditorCompetitionId = (
    id: string,
    updateCompetitionRequest: UpdateCompetitionRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/competition/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCompetitionRequest,
    });
  };

  /**
   * Deletes an existing competition by its identifier
   * @summary Deletes an existing competition
   */
  const deleteApiV1EditorCompetitionId = (id: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/competition/${id}`,
      method: 'DELETE',
    });
  };

  /**
   * Creates a new country
   * @summary Creates a new country
   */
  const postApiV1EditorCountry = (
    createCountryRequest: CreateCountryRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/country`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCountryRequest,
    });
  };

  /**
   * Updates an existing country
   * @summary Updates an existing country
   */
  const patchApiV1EditorCountryId = (
    id: string,
    updateCountryRequest: UpdateCountryRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/country/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCountryRequest,
    });
  };

  /**
   * Deletes an existing country by its identifier
   * @summary Deletes an existing country
   */
  const deleteApiV1EditorCountryId = (id: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/country/${id}`,
      method: 'DELETE',
    });
  };

  /**
   * Creates a new event pool to which events can be added later
   * @summary Creates a new event pool
   */
  const postApiV1EditorPool = (
    createEventPoolRequest: CreateEventPoolRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEventPoolRequest,
    });
  };

  /**
   * Updates an existing event pool
   * @summary Updates an existing event pool
   */
  const patchApiV1EditorPoolId = (
    id: string,
    updateEventPoolRequest: UpdateEventPoolRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEventPoolRequest,
    });
  };

  /**
   * Deletes an existing event pool by its identifier
   * @summary Deletes an existing event pool
   */
  const deleteApiV1EditorPoolId = (id: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool/${id}`,
      method: 'DELETE',
    });
  };

  /**
   * Closes the event pool and calculates the results
   * @summary Close event pool
   */
  const postApiV1EditorPoolCloseSingle = (
    params?: PostApiV1EditorPoolCloseSingleParams,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool/close/single`,
      method: 'POST',
      params,
    });
  };

  /**
   * Adds an existing event to an existing event pool
   * @summary Adds an event to an event pool
   */
  const postApiV1EditorPoolAddEvent = (
    addEventsToPoolRequest: AddEventsToPoolRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool/add/event`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addEventsToPoolRequest,
    });
  };

  /**
   * Removes an existing event from an existing event pool
   * @summary Remove an event from an event pool
   */
  const deleteApiV1EditorPoolRemoveEvent = (
    params?: DeleteApiV1EditorPoolRemoveEventParams,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/pool/remove/event`,
      method: 'DELETE',
      params,
    });
  };

  /**
   * Creates a new event that can later be added to an event pool
   * @summary Creates a new event
   */
  const postApiV1EditorEvent = (createEventRequest: CreateEventRequest) => {
    return apiClient<void>({
      url: `/api/v1/editor/event`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEventRequest,
    });
  };

  /**
   * Creates a new event collections that can later be added to an event pool
   * @summary Creates a new event collection
   */
  const postApiV1EditorEventCollection = (
    createEventsRequest: CreateEventsRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/event/collection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEventsRequest,
    });
  };

  /**
   * Updates an existing event and also updates the teams associated with it
   * @summary Updates an existing event
   */
  const patchApiV1EditorEventId = (
    id: string,
    updateEventRequest: UpdateEventRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/event/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEventRequest,
    });
  };

  /**
   * Deletes an existing event by its identifier
   * @summary Deletes an existing event
   */
  const deleteApiV1EditorEventId = (id: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/event/${id}`,
      method: 'DELETE',
    });
  };

  /**
   * @summary Import events from DTO
   */
  const postApiV1EditorEventImportEvents = (
    createEventRequest: CreateEventRequest[],
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/event/import-events`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEventRequest,
    });
  };

  /**
   * Retrieves the configured RP and SC reward of every rewarded place, optionally filtered by giveaway kind
   * @summary Retrieves giveaway place rewards
   */
  const getApiV1EditorGiveawayPlaceRewards = (
    params?: GetApiV1EditorGiveawayPlaceRewardsParams,
  ) => {
    return apiClient<GiveawayPlaceRewardCollectionDetailsResponseContent>({
      url: `/api/v1/editor/giveaway/place-rewards`,
      method: 'GET',
      params,
    });
  };

  /**
   * Updates the RP and SC reward paid for the given place of the given giveaway kind
   * @summary Updates a giveaway place reward
   */
  const patchApiV1EditorGiveawayPlaceRewardsKindPlace = (
    kind: GiveawayKind,
    place: number,
    updateGiveawayPlaceRewardRequest: UpdateGiveawayPlaceRewardRequest,
  ) => {
    return apiClient<GiveawayPlaceRewardDetailsResponseContent>({
      url: `/api/v1/editor/giveaway/place-rewards/${kind}/${place}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateGiveawayPlaceRewardRequest,
    });
  };

  /**
   * Creates equipment and binds uploaded image to created equipment
   * @summary Creates equipment with media
   */
  const postApiV1EditorInventoryEquipment = (
    postApiV1EditorInventoryEquipmentBody: PostApiV1EditorInventoryEquipmentBody,
  ) => {
    const formData = new FormData();
    formData.append(`File`, postApiV1EditorInventoryEquipmentBody.File);
    formData.append(
      `TargetUserId`,
      postApiV1EditorInventoryEquipmentBody.TargetUserId,
    );
    formData.append(
      `Level`,
      postApiV1EditorInventoryEquipmentBody.Level.toString(),
    );
    formData.append(`Rarity`, postApiV1EditorInventoryEquipmentBody.Rarity);
    formData.append(
      `Comfort`,
      postApiV1EditorInventoryEquipmentBody.Comfort.toString(),
    );
    formData.append(
      `Style`,
      postApiV1EditorInventoryEquipmentBody.Style.toString(),
    );
    formData.append(
      `WearResistance`,
      postApiV1EditorInventoryEquipmentBody.WearResistance.toString(),
    );
    formData.append(
      `Luckiness`,
      postApiV1EditorInventoryEquipmentBody.Luckiness.toString(),
    );
    formData.append(
      `Cleanness`,
      postApiV1EditorInventoryEquipmentBody.Cleanness.toString(),
    );
    formData.append(
      `Durability`,
      postApiV1EditorInventoryEquipmentBody.Durability.toString(),
    );
    formData.append(
      `Energy`,
      postApiV1EditorInventoryEquipmentBody.Energy.toString(),
    );

    return apiClient<EquipmentDetailsResponseContent>({
      url: `/api/v1/editor/inventory/equipment`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  /**
   * Creates accessory and binds uploaded image to created accessory
   * @summary Creates accessory with media
   */
  const postApiV1EditorInventoryAccessory = (
    postApiV1EditorInventoryAccessoryBody: PostApiV1EditorInventoryAccessoryBody,
  ) => {
    const formData = new FormData();
    formData.append(`File`, postApiV1EditorInventoryAccessoryBody.File);
    formData.append(
      `EquipmentId`,
      postApiV1EditorInventoryAccessoryBody.EquipmentId,
    );
    formData.append(`Type`, postApiV1EditorInventoryAccessoryBody.Type);
    formData.append(`Rarity`, postApiV1EditorInventoryAccessoryBody.Rarity);
    formData.append(
      `ComfortBonus`,
      postApiV1EditorInventoryAccessoryBody.ComfortBonus.toString(),
    );
    formData.append(
      `StyleBonus`,
      postApiV1EditorInventoryAccessoryBody.StyleBonus.toString(),
    );
    formData.append(
      `WearResistanceBonus`,
      postApiV1EditorInventoryAccessoryBody.WearResistanceBonus.toString(),
    );
    formData.append(
      `LuckinessBonus`,
      postApiV1EditorInventoryAccessoryBody.LuckinessBonus.toString(),
    );

    return apiClient<AccessoryDetailsResponseContent>({
      url: `/api/v1/editor/inventory/accessory`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  /**
   * Creates a single unopened patch box of the given rarity for the target user; the box uses the regular opening timer and respects the user's patch box capacity
   * @summary Grants a patch box to a user
   */
  const postApiV1EditorInventoryUsersUserIdPatchBoxes = (
    userId: string,
    grantUserPatchBoxRequest: GrantUserPatchBoxRequest,
  ) => {
    return apiClient<UserPatchBoxDetailsResponseContent>({
      url: `/api/v1/editor/inventory/users/${userId}/patch-boxes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: grantUserPatchBoxRequest,
    });
  };

  /**
   * Creates a single unopened loot bag of the given rarity for the target user; the bag uses the regular opening timer and is marked with the Admin source
   * @summary Grants a loot bag to a user
   */
  const postApiV1EditorInventoryUsersUserIdLootBags = (
    userId: string,
    grantUserLootBagRequest: GrantUserLootBagRequest,
  ) => {
    return apiClient<UserLootBagDetailsResponseContent>({
      url: `/api/v1/editor/inventory/users/${userId}/loot-bags`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: grantUserLootBagRequest,
    });
  };

  /**
   * Retrieves the Patch price of a single durability point and the discounted price of a full bar restore for every configured rarity
   * @summary Retrieves equipment restore settings
   */
  const getApiV1EditorInventoryEquipmentRestoreSettings = () => {
    return apiClient<EquipmentRestoreSettingsCollectionDetailsResponseContent>({
      url: `/api/v1/editor/inventory/equipment/restore-settings`,
      method: 'GET',
    });
  };

  /**
   * Sets the Patch price of a single durability point and the Patch price of restoring the whole bar in one purchase; the discount is derived from both prices
   * @summary Updates equipment restore settings
   */
  const patchApiV1EditorInventoryEquipmentRestoreSettingsRarity = (
    rarity: EquipmentRarity,
    updateEquipmentRestoreSettingsRequest: UpdateEquipmentRestoreSettingsRequest,
  ) => {
    return apiClient<EquipmentRestoreSettingsDetailsResponseContent>({
      url: `/api/v1/editor/inventory/equipment/restore-settings/${rarity}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEquipmentRestoreSettingsRequest,
    });
  };

  /**
   * Retrieves ticket drop chances for every loot bag rarity
   * @summary Retrieves loot bag ticket drop rules
   */
  const getApiV1EditorInventoryLootBagsTicketDropRules = () => {
    return apiClient<LootBagTicketDropRuleCollectionDetailsResponseContent>({
      url: `/api/v1/editor/inventory/loot-bags/ticket-drop-rules`,
      method: 'GET',
    });
  };

  /**
   * Updates the ticket drop chance of the given loot bag rarity
   * @summary Updates loot bag ticket drop rule
   */
  const patchApiV1EditorInventoryLootBagsTicketDropRulesRarity = (
    rarity: LootBagRarity,
    updateLootBagTicketDropRuleRequest: UpdateLootBagTicketDropRuleRequest,
  ) => {
    return apiClient<LootBagTicketDropRuleDetailsResponseContent>({
      url: `/api/v1/editor/inventory/loot-bags/ticket-drop-rules/${rarity}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateLootBagTicketDropRuleRequest,
    });
  };

  /**
   * Uploads a media file into configured S3 storage and creates media metadata
   * @summary Uploads media file to storage
   */
  const postApiV1EditorMediaUpload = (
    postApiV1EditorMediaUploadBody: PostApiV1EditorMediaUploadBody,
  ) => {
    const formData = new FormData();
    formData.append(`File`, postApiV1EditorMediaUploadBody.File);
    formData.append(`Folder`, postApiV1EditorMediaUploadBody.Folder);
    formData.append(`OwnerDomain`, postApiV1EditorMediaUploadBody.OwnerDomain);
    formData.append(`OwnerType`, postApiV1EditorMediaUploadBody.OwnerType);
    formData.append(`OwnerKey`, postApiV1EditorMediaUploadBody.OwnerKey);

    return apiClient<MediaAssetDetailsResponseContent>({
      url: `/api/v1/editor/media/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  /**
   * Removes media metadata and underlying object from storage
   * @summary Removes media file
   */
  const deleteApiV1EditorMediaMediaAssetId = (mediaAssetId: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/media/${mediaAssetId}`,
      method: 'DELETE',
    });
  };

  /**
   * Creates a new team
   * @summary Creates a new team
   */
  const postApiV1EditorTeam = (
    postApiV1EditorTeamBody: PostApiV1EditorTeamBody,
  ) => {
    const formData = new FormData();
    if (postApiV1EditorTeamBody.Emblem !== undefined) {
      formData.append(`Emblem`, postApiV1EditorTeamBody.Emblem);
    }
    formData.append(`TeamName`, postApiV1EditorTeamBody.TeamName);

    return apiClient<void>({
      url: `/api/v1/editor/team`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  /**
   * Updates an existing team
   * @summary Updates an existing team
   */
  const patchApiV1EditorTeamId = (
    id: string,
    patchApiV1EditorTeamIdBody: PatchApiV1EditorTeamIdBody,
  ) => {
    const formData = new FormData();
    if (patchApiV1EditorTeamIdBody.Emblem !== undefined) {
      formData.append(`Emblem`, patchApiV1EditorTeamIdBody.Emblem);
    }
    formData.append(`TeamName`, patchApiV1EditorTeamIdBody.TeamName);

    return apiClient<void>({
      url: `/api/v1/editor/team/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  /**
   * Deletes an existing team by its identifier
   * @summary Deletes an existing team
   */
  const deleteApiV1EditorTeamId = (id: string) => {
    return apiClient<void>({
      url: `/api/v1/editor/team/${id}`,
      method: 'DELETE',
    });
  };

  /**
   * Bans selected user
   * @summary Bans user
   */
  const patchApiV1EditorUserIdBan = (
    id: string,
    banUserRequest: BanUserRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/user/${id}/ban`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: banUserRequest,
    });
  };

  /**
   * Unbans selected user
   * @summary Unbans user
   */
  const patchApiV1EditorUserIdUnban = (
    id: string,
    unbanUserRequest: UnbanUserRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/user/${id}/unban`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: unbanUserRequest,
    });
  };

  /**
   * Applies a signed manual adjustment to a single wallet currency and records the change in wallet transactions
   * @summary Manually adjusts a user's wallet balance
   */
  const patchApiV1EditorWalletUserIdAdjust = (
    userId: string,
    adjustWalletBalanceRequest: AdjustWalletBalanceRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/editor/wallet/${userId}/adjust`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: adjustWalletBalanceRequest,
    });
  };

  /**
   * Retrieves an event pool by its identifier
   * @summary Retrieves an existing event pool
   */
  const getApiV1EventPoolId = (id: string) => {
    return apiClient<EventPoolDetailsResponseContent>({
      url: `/api/v1/event/pool/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves all event pools for the given date and mode
   * @summary Retrieves event pools
   */
  const getApiV1EventPoolFilter = (params: GetApiV1EventPoolFilterParams) => {
    return apiClient<EventPoolCollectionDetailsResponseContent>({
      url: `/api/v1/event/pool/filter`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves event pools with pagination and sorting by mode
   * @summary Retrieves event pools
   */
  const getApiV1EventPoolCollection = (
    params?: GetApiV1EventPoolCollectionParams,
  ) => {
    return apiClient<EventPoolCollectionDetailsResponseContent>({
      url: `/api/v1/event/pool/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves your duel entries. The opponent appears once the pool is matched, right after the forecast deadline; the score appears once the game day is over and the duel is settled. Follow Stage instead of guessing by the nullable fields
   * @summary Retrieves your duel matches
   */
  const getApiV1EventPoolDuelMatches = (
    params?: GetApiV1EventPoolDuelMatchesParams,
  ) => {
    return apiClient<DuelMatchCollectionDetailsResponseContent>({
      url: `/api/v1/event/pool/duel/matches`,
      method: 'GET',
      params,
    });
  };

  /**
   * Creates a duel entry for the current user in the selected duel event pool
   * @summary Creates duel entry in event pool
   */
  const postApiV1EventPoolDuelEntry = (
    createDuelEntryRequest: CreateDuelEntryRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/event/pool/duel/entry`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDuelEntryRequest,
    });
  };

  /**
   * Retrieves an event by its identifier
   * @summary Retrieves an existing event
   */
  const getApiV1EventId = (id: string) => {
    return apiClient<EventDetailsResponseContent>({
      url: `/api/v1/event/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves events with pagination and sorting by start date
   * @summary Retrieves existing events
   */
  const getApiV1EventCollection = (params?: GetApiV1EventCollectionParams) => {
    return apiClient<EventCollectionDetailsResponseContent>({
      url: `/api/v1/event/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves your match forecasts with pagination and an aggregate IsGiveawayEntry flag for the requested event pool
   * @summary Retrieves your match forecasts from all event pools with Single mode
   */
  const getApiV1ForecastSingle = (params?: GetApiV1ForecastSingleParams) => {
    return apiClient<EventForecastCollectionDetailsResponseContent>({
      url: `/api/v1/forecast/single`,
      method: 'GET',
      params,
    });
  };

  /**
   * Creates or updates existing match forecasts from a specific event pool with Single mode
   * @summary Creates match forecasts from a specific event pool with Single mode
   */
  const postApiV1ForecastSingle = (
    createSingleModeForecastEventsRequest: CreateSingleModeForecastEventsRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/forecast/single`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSingleModeForecastEventsRequest,
    });
  };

  /**
   * Retrieves your match forecasts from all event pools with Duel mode, with pagination and sorting by creation date
   * @summary Retrieves your match forecasts from all event pools with Duel mode
   */
  const getApiV1ForecastDuel = (params?: GetApiV1ForecastDuelParams) => {
    return apiClient<EventForecastCollectionDetailsResponseContent>({
      url: `/api/v1/forecast/duel`,
      method: 'GET',
      params,
    });
  };

  /**
   * Creates or updates existing match forecasts from a specific event pool with Duel mode
   * @summary Creates match forecasts from a specific event pool with Duel mode
   */
  const postApiV1ForecastDuel = (
    createDuelModeForecastsEventRequest: CreateDuelModeForecastsEventRequest,
  ) => {
    return apiClient<void>({
      url: `/api/v1/forecast/duel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDuelModeForecastsEventRequest,
    });
  };

  /**
   * Returns a weekly or all-time leaderboard with an active-week countdown
   * @summary Retrieves the single giveaway leaderboard
   */
  const getApiV1GiveawaySingleLeaderboard = (
    params?: GetApiV1GiveawaySingleLeaderboardParams,
  ) => {
    return apiClient<SingleGiveawayLeaderboardDetailsResponseContent>({
      url: `/api/v1/giveaway/single/leaderboard`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves daily single, weekly single and weekly duel results by period
   * @summary Retrieves giveaway results
   */
  const getApiV1GiveawayCollection = (
    params?: GetApiV1GiveawayCollectionParams,
  ) => {
    return apiClient<GiveawayResultCollectionDetailsResponseContent>({
      url: `/api/v1/giveaway/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves the complete leaderboard for a giveaway result
   * @summary Retrieves giveaway leaderboard
   */
  const getApiV1GiveawayId = (id: string) => {
    return apiClient<GiveawayResultDetailsResponseContent>({
      url: `/api/v1/giveaway/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves patch boxes with pagination and sorting by rarity
   * @summary Retrieves existing patch boxes
   */
  const getApiV1InventoryCollection = (
    params?: GetApiV1InventoryCollectionParams,
  ) => {
    return apiClient<PatchBoxCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves patch box by rarity
   * @summary Retrieves existing patch box
   */
  const getApiV1InventoryFilter = (params?: GetApiV1InventoryFilterParams) => {
    return apiClient<PatchBoxDetailsResponseContent>({
      url: `/api/v1/inventory/filter`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves patch box by its identifier
   * @summary Retrieves existing patch box
   */
  const getApiV1InventoryId = (id: string) => {
    return apiClient<PatchBoxDetailsResponseContent>({
      url: `/api/v1/inventory/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves patch boxes that the user has in inventory
   * @summary Retrieves user patch boxes
   */
  const getApiV1InventoryOwnPatchBoxesCollection = (
    params?: GetApiV1InventoryOwnPatchBoxesCollectionParams,
  ) => {
    return apiClient<UserPatchBoxCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/own/patch-boxes/collection`,
      method: 'GET',
      params,
    });
  };

  const postApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpen = (
    userPatchBoxId: string,
    params?: PostApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpenParams,
  ) => {
    return apiClient<OpenPatchBoxResultDetailsResponseContent>({
      url: `/api/v1/inventory/own/patch-boxes/${userPatchBoxId}/open`,
      method: 'POST',
      params,
    });
  };

  /**
   * Retrieves loot bags that the user has in inventory
   * @summary Retrieves user loot bags
   */
  const getApiV1InventoryOwnLootBagsCollection = (
    params?: GetApiV1InventoryOwnLootBagsCollectionParams,
  ) => {
    return apiClient<UserLootBagCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/own/loot-bags/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Opens a loot bag and moves its equipment and accessories into the inventory
   * @summary Opens a loot bag
   */
  const postApiV1InventoryOwnLootBagsUserLootBagIdOpen = (
    userLootBagId: string,
    params?: PostApiV1InventoryOwnLootBagsUserLootBagIdOpenParams,
  ) => {
    return apiClient<OpenLootBagResultDetailsResponseContent>({
      url: `/api/v1/inventory/own/loot-bags/${userLootBagId}/open`,
      method: 'POST',
      params,
    });
  };

  /**
   * Retrieves equipment that the current user owns, with pagination. When CrossWithEquipmentId is set, returns only equipment that can be crossed with that equipment
   * @summary Retrieves user equipment
   */
  const getApiV1InventoryOwnEquipmentCollection = (
    params?: GetApiV1InventoryOwnEquipmentCollectionParams,
  ) => {
    return apiClient<EquipmentCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/own/equipment/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves accessories that the current user owns, with pagination and filters by rarity and equipment. When MergeWithAccessoryId is set, returns only accessories that can be merged with that accessory
   * @summary Retrieves user accessories
   */
  const getApiV1InventoryOwnAccessoriesCollection = (
    params?: GetApiV1InventoryOwnAccessoriesCollectionParams,
  ) => {
    return apiClient<AccessoryCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/own/accessories/collection`,
      method: 'GET',
      params,
    });
  };

  const getApiV1InventoryEquipmentId = (id: string) => {
    return apiClient<EquipmentDetailsResponseContent>({
      url: `/api/v1/inventory/equipment/${id}`,
      method: 'GET',
    });
  };

  const getApiV1InventoryAccessoriesId = (id: string) => {
    return apiClient<AccessoryDetailsResponseContent>({
      url: `/api/v1/inventory/accessories/${id}`,
      method: 'GET',
    });
  };

  const postApiV1InventoryEquipmentCross = (
    crossEquipmentsRequest: CrossEquipmentsRequest,
  ) => {
    return apiClient<CrossEquipmentResultDetailsResponseContent>({
      url: `/api/v1/inventory/equipment/cross`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: crossEquipmentsRequest,
    });
  };

  /**
   * Validates the selected equipment and returns the current RP cost
   * @summary Retrieves equipment cross cost
   */
  const getApiV1InventoryEquipmentCrossCost = (
    params?: GetApiV1InventoryEquipmentCrossCostParams,
  ) => {
    return apiClient<InventoryOperationRpCostDetailsResponseContent>({
      url: `/api/v1/inventory/equipment/cross/cost`,
      method: 'GET',
      params,
    });
  };

  const postApiV1InventoryEquipmentEquipmentIdUpgradeLevel = (
    equipmentId: string,
  ) => {
    return apiClient<UpgradeEquipmentLevelResultDetailsResponseContent>({
      url: `/api/v1/inventory/equipment/${equipmentId}/upgrade-level`,
      method: 'POST',
    });
  };

  /**
   * Restores whole durability points by spending Patch currency; the price per point depends on the equipment rarity and is returned in EquipmentDetails.RepairCost. Restoring the bar up to its maximum in one request applies the rarity discount
   * @summary Restores equipment durability
   */
  const postApiV1InventoryEquipmentEquipmentIdRestoreDurability = (
    equipmentId: string,
    restoreEquipmentDurabilityRequest: RestoreEquipmentDurabilityRequest,
  ) => {
    return apiClient<RestoreEquipmentDurabilityResultDetailsResponseContent>({
      url: `/api/v1/inventory/equipment/${equipmentId}/restore-durability`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: restoreEquipmentDurabilityRequest,
    });
  };

  const postApiV1InventoryAccessoriesMerge = (
    mergeAccessoriesRequest: MergeAccessoriesRequest,
  ) => {
    return apiClient<MergeAccessoriesResultDetailsResponseContent>({
      url: `/api/v1/inventory/accessories/merge`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: mergeAccessoriesRequest,
    });
  };

  /**
   * Validates the selected accessories and returns the current RP cost
   * @summary Retrieves accessory merge cost
   */
  const getApiV1InventoryAccessoriesMergeCost = (
    params?: GetApiV1InventoryAccessoriesMergeCostParams,
  ) => {
    return apiClient<InventoryOperationRpCostDetailsResponseContent>({
      url: `/api/v1/inventory/accessories/merge/cost`,
      method: 'GET',
      params,
    });
  };

  const postApiV1InventoryAccessoriesAccessoryIdEquipEquipmentId = (
    accessoryId: string,
    equipmentId: string,
  ) => {
    return apiClient<void>({
      url: `/api/v1/inventory/accessories/${accessoryId}/equip/${equipmentId}`,
      method: 'POST',
    });
  };

  const postApiV1InventoryAccessoriesAccessoryIdUnequip = (
    accessoryId: string,
  ) => {
    return apiClient<void>({
      url: `/api/v1/inventory/accessories/${accessoryId}/unequip`,
      method: 'POST',
    });
  };

  const getApiV1InventoryMarketListings = (
    params?: GetApiV1InventoryMarketListingsParams,
  ) => {
    return apiClient<MarketListingCollectionDetailsResponseContent>({
      url: `/api/v1/inventory/market/listings`,
      method: 'GET',
      params,
    });
  };

  const postApiV1InventoryMarketEquipmentEquipmentIdSell = (
    equipmentId: string,
    sellMarketItemRequest: SellMarketItemRequest,
  ) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/equipment/${equipmentId}/sell`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sellMarketItemRequest,
    });
  };

  const postApiV1InventoryMarketAccessoryAccessoryIdSell = (
    accessoryId: string,
    sellMarketItemRequest: SellMarketItemRequest,
  ) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/accessory/${accessoryId}/sell`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sellMarketItemRequest,
    });
  };

  const postApiV1InventoryMarketListingsListingIdBuy = (listingId: string) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/listings/${listingId}/buy`,
      method: 'POST',
    });
  };

  const postApiV1InventoryMarketEquipmentEquipmentIdBuy = (
    equipmentId: string,
  ) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/equipment/${equipmentId}/buy`,
      method: 'POST',
    });
  };

  const postApiV1InventoryMarketAccessoryAccessoryIdBuy = (
    accessoryId: string,
  ) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/accessory/${accessoryId}/buy`,
      method: 'POST',
    });
  };

  const deleteApiV1InventoryMarketListingsListingId = (listingId: string) => {
    return apiClient<MarketListingDetailsResponseContent>({
      url: `/api/v1/inventory/market/listings/${listingId}`,
      method: 'DELETE',
    });
  };

  /**
   * Returns signed S3 URL and file metadata
   * @summary Retrieves media file access metadata by relative path
   */
  const getApiV1MediaFilesRelativePath = (relativePath: string) => {
    return apiClient<MediaFileDetailsResponseContent>({
      url: `/api/v1/media/files/${relativePath}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves a notification by its identifier. Match-result notifications include the structured MatchResult payload and (for duel) the equipment used.
   * @summary Retrieves an existing notification
   */
  const getApiV1NotificationId = (id: string) => {
    return apiClient<NotificationDetailsResponseContent>({
      url: `/api/v1/notification/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves notifications for the current user with pagination and optional filtering by notification type. Match-result entries include the structured MatchResult payload. Requesting the list marks the user's notifications as seen (clears the unread flag).
   * @summary Retrieves notifications
   */
  const getApiV1NotificationCollection = (
    params?: GetApiV1NotificationCollectionParams,
  ) => {
    return apiClient<NotificationCollectionDetailsResponseContent>({
      url: `/api/v1/notification/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Returns whether the current user has any unread notifications. Lightweight read from the shared cache; the flag is cleared when the user requests the notifications collection.
   * @summary Checks for unread notifications
   */
  const getApiV1NotificationUnread = () => {
    return apiClient<UnreadNotificationStatusDetailsResponseContent>({
      url: `/api/v1/notification/unread`,
      method: 'GET',
    });
  };

  /**
   * Retrieves the current user's referral details
   * @summary Retrieves current user referrals
   */
  const getApiV1ReferralsCurrent = () => {
    return apiClient<ReferralDetailsResponseContent>({
      url: `/api/v1/referrals/current`,
      method: 'GET',
    });
  };

  /**
   * Retrieves a team by its identifier
   * @summary Retrieves an existing team
   */
  const getApiV1TeamId = (id: string) => {
    return apiClient<EventTeamDetailsResponseContent>({
      url: `/api/v1/team/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves teams with pagination
   * @summary Retrieves existing teams
   */
  const getApiV1TeamCollection = (params?: GetApiV1TeamCollectionParams) => {
    return apiClient<TeamCollectionDetailsResponseContent>({
      url: `/api/v1/team/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves profile information for a selected user
   * @summary Retrieves profile data by identifier
   */
  const getApiV1UserId = (id: string) => {
    return apiClient<ProfileDetailsByIdResponseContent>({
      url: `/api/v1/user/${id}`,
      method: 'GET',
    });
  };

  /**
   * Retrieves users with pagination and optional profile filters
   * @summary Retrieves users
   */
  const getApiV1UserCollection = (params?: GetApiV1UserCollectionParams) => {
    return apiClient<ProfileCollectionDetailsResponseContent>({
      url: `/api/v1/user/collection`,
      method: 'GET',
      params,
    });
  };

  /**
   * Retrieves the main profile information
   * @summary Retrieves profile data
   */
  const getApiV1UserProfile = () => {
    return apiClient<ProfileDetailsResponseContent>({
      url: `/api/v1/user/profile`,
      method: 'GET',
    });
  };

  /**
   * Retrieves overall and mode-specific user statistics
   * @summary Retrieves user statistics
   */
  const getApiV1UserStatistic = () => {
    return apiClient<StatisticDetailsResponseContent>({
      url: `/api/v1/user/statistic`,
      method: 'GET',
    });
  };

  /**
   * Retrieves the user's wallet and transaction history
   * @summary Retrieves user wallet
   */
  const getApiV1UserWallet = () => {
    return apiClient<WalletDetailsResponseContent>({
      url: `/api/v1/user/wallet`,
      method: 'GET',
    });
  };

  /**
   * Retrieves the current price of one ticket in RP
   * @summary Retrieves the RP-to-ticket conversion rate
   */
  const getApiV1UserWalletTicketConversionRate = () => {
    return apiClient<TicketConversionRateDetailsResponseContent>({
      url: `/api/v1/user/wallet/ticket-conversion-rate`,
      method: 'GET',
    });
  };

  /**
   * Converts RP into the requested positive number of tickets using the current rate
   * @summary Converts RP into tickets
   */
  const postApiV1UserWalletTicketConversions = (
    convertRpToTicketsRequest: ConvertRpToTicketsRequest,
  ) => {
    return apiClient<RpToTicketConversionDetailsResponseContent>({
      url: `/api/v1/user/wallet/ticket-conversions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: convertRpToTicketsRequest,
    });
  };

  /**
   * Retrieves the current user's wallet financial operations for the selected period with pagination and optional filtering by currency
   * @summary Retrieves wallet operations history
   */
  const getApiV1UserWalletTransactions = (
    params?: GetApiV1UserWalletTransactionsParams,
  ) => {
    return apiClient<WalletTransactionCollectionDetailsResponseContent>({
      url: `/api/v1/user/wallet/transactions`,
      method: 'GET',
      params,
    });
  };

  return {
    patchApiV1AccountDeletionMark,
    patchApiV1AccountDeletionUnmark,
    patchApiV1AccountUsername,
    patchApiV1AccountAvatar,
    patchApiV1AccountAge,
    patchApiV1AccountGender,
    patchApiV1AccountLanguage,
    getApiV1AccountOnboardingStatus,
    patchApiV1AccountOnboardingComplete,
    postApiV1AuthAuditAuthorize,
    postApiV1AuthAuthorize,
    postApiV1AuthRegister,
    postApiV1AuthCheckAvailability,
    postApiV1AuthCode,
    postApiV1AuthForgotPassword,
    patchApiV1AuthPassword,
    postApiV1AuthRestoreAccount,
    postApiV1AuthRefresh,
    getApiV1AvatarCatalog,
    getApiV1AvatarCatalogImageCategoryValue,
    getApiV1AvatarPreview,
    getApiV1AvatarRandom,
    getApiV1AvatarDraft,
    putApiV1AvatarDraft,
    getApiV1CompetitionId,
    getApiV1CompetitionCollectionCountryId,
    getApiV1CompetitionCollection,
    getApiV1CountryId,
    getApiV1CountryCollection,
    postApiV1EditorCompetition,
    patchApiV1EditorCompetitionId,
    deleteApiV1EditorCompetitionId,
    postApiV1EditorCountry,
    patchApiV1EditorCountryId,
    deleteApiV1EditorCountryId,
    postApiV1EditorPool,
    patchApiV1EditorPoolId,
    deleteApiV1EditorPoolId,
    postApiV1EditorPoolCloseSingle,
    postApiV1EditorPoolAddEvent,
    deleteApiV1EditorPoolRemoveEvent,
    postApiV1EditorEvent,
    postApiV1EditorEventCollection,
    patchApiV1EditorEventId,
    deleteApiV1EditorEventId,
    postApiV1EditorEventImportEvents,
    getApiV1EditorGiveawayPlaceRewards,
    patchApiV1EditorGiveawayPlaceRewardsKindPlace,
    postApiV1EditorInventoryEquipment,
    postApiV1EditorInventoryAccessory,
    postApiV1EditorInventoryUsersUserIdPatchBoxes,
    postApiV1EditorInventoryUsersUserIdLootBags,
    getApiV1EditorInventoryEquipmentRestoreSettings,
    patchApiV1EditorInventoryEquipmentRestoreSettingsRarity,
    getApiV1EditorInventoryLootBagsTicketDropRules,
    patchApiV1EditorInventoryLootBagsTicketDropRulesRarity,
    postApiV1EditorMediaUpload,
    deleteApiV1EditorMediaMediaAssetId,
    postApiV1EditorTeam,
    patchApiV1EditorTeamId,
    deleteApiV1EditorTeamId,
    patchApiV1EditorUserIdBan,
    patchApiV1EditorUserIdUnban,
    patchApiV1EditorWalletUserIdAdjust,
    getApiV1EventPoolId,
    getApiV1EventPoolFilter,
    getApiV1EventPoolCollection,
    getApiV1EventPoolDuelMatches,
    postApiV1EventPoolDuelEntry,
    getApiV1EventId,
    getApiV1EventCollection,
    getApiV1ForecastSingle,
    postApiV1ForecastSingle,
    getApiV1ForecastDuel,
    postApiV1ForecastDuel,
    getApiV1GiveawaySingleLeaderboard,
    getApiV1GiveawayCollection,
    getApiV1GiveawayId,
    getApiV1InventoryCollection,
    getApiV1InventoryFilter,
    getApiV1InventoryId,
    getApiV1InventoryOwnPatchBoxesCollection,
    postApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpen,
    getApiV1InventoryOwnLootBagsCollection,
    postApiV1InventoryOwnLootBagsUserLootBagIdOpen,
    getApiV1InventoryOwnEquipmentCollection,
    getApiV1InventoryOwnAccessoriesCollection,
    getApiV1InventoryEquipmentId,
    getApiV1InventoryAccessoriesId,
    postApiV1InventoryEquipmentCross,
    getApiV1InventoryEquipmentCrossCost,
    postApiV1InventoryEquipmentEquipmentIdUpgradeLevel,
    postApiV1InventoryEquipmentEquipmentIdRestoreDurability,
    postApiV1InventoryAccessoriesMerge,
    getApiV1InventoryAccessoriesMergeCost,
    postApiV1InventoryAccessoriesAccessoryIdEquipEquipmentId,
    postApiV1InventoryAccessoriesAccessoryIdUnequip,
    getApiV1InventoryMarketListings,
    postApiV1InventoryMarketEquipmentEquipmentIdSell,
    postApiV1InventoryMarketAccessoryAccessoryIdSell,
    postApiV1InventoryMarketListingsListingIdBuy,
    postApiV1InventoryMarketEquipmentEquipmentIdBuy,
    postApiV1InventoryMarketAccessoryAccessoryIdBuy,
    deleteApiV1InventoryMarketListingsListingId,
    getApiV1MediaFilesRelativePath,
    getApiV1NotificationId,
    getApiV1NotificationCollection,
    getApiV1NotificationUnread,
    getApiV1ReferralsCurrent,
    getApiV1TeamId,
    getApiV1TeamCollection,
    getApiV1UserId,
    getApiV1UserCollection,
    getApiV1UserProfile,
    getApiV1UserStatistic,
    getApiV1UserWallet,
    getApiV1UserWalletTicketConversionRate,
    postApiV1UserWalletTicketConversions,
    getApiV1UserWalletTransactions,
  };
};
export type PatchApiV1AccountDeletionMarkResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountDeletionMark']
    >
  >
>;
export type PatchApiV1AccountDeletionUnmarkResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountDeletionUnmark']
    >
  >
>;
export type PatchApiV1AccountUsernameResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountUsername']
    >
  >
>;
export type PatchApiV1AccountAvatarResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountAvatar']
    >
  >
>;
export type PatchApiV1AccountAgeResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['patchApiV1AccountAge']
    >
  >
>;
export type PatchApiV1AccountGenderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountGender']
    >
  >
>;
export type PatchApiV1AccountLanguageResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountLanguage']
    >
  >
>;
export type GetApiV1AccountOnboardingStatusResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1AccountOnboardingStatus']
    >
  >
>;
export type PatchApiV1AccountOnboardingCompleteResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AccountOnboardingComplete']
    >
  >
>;
export type PostApiV1AuthAuditAuthorizeResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthAuditAuthorize']
    >
  >
>;
export type PostApiV1AuthAuthorizeResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthAuthorize']
    >
  >
>;
export type PostApiV1AuthRegisterResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthRegister']
    >
  >
>;
export type PostApiV1AuthCheckAvailabilityResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthCheckAvailability']
    >
  >
>;
export type PostApiV1AuthCodeResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['postApiV1AuthCode']
    >
  >
>;
export type PostApiV1AuthForgotPasswordResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthForgotPassword']
    >
  >
>;
export type PatchApiV1AuthPasswordResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1AuthPassword']
    >
  >
>;
export type PostApiV1AuthRestoreAccountResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1AuthRestoreAccount']
    >
  >
>;
export type PostApiV1AuthRefreshResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['postApiV1AuthRefresh']
    >
  >
>;
export type GetApiV1AvatarCatalogResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1AvatarCatalog']
    >
  >
>;
export type GetApiV1AvatarCatalogImageCategoryValueResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1AvatarCatalogImageCategoryValue']
    >
  >
>;
export type GetApiV1AvatarPreviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1AvatarPreview']
    >
  >
>;
export type GetApiV1AvatarRandomResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1AvatarRandom']
    >
  >
>;
export type GetApiV1AvatarDraftResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1AvatarDraft']
    >
  >
>;
export type PutApiV1AvatarDraftResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['putApiV1AvatarDraft']
    >
  >
>;
export type GetApiV1CompetitionIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1CompetitionId']
    >
  >
>;
export type GetApiV1CompetitionCollectionCountryIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1CompetitionCollectionCountryId']
    >
  >
>;
export type GetApiV1CompetitionCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1CompetitionCollection']
    >
  >
>;
export type GetApiV1CountryIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1CountryId']
    >
  >
>;
export type GetApiV1CountryCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1CountryCollection']
    >
  >
>;
export type PostApiV1EditorCompetitionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorCompetition']
    >
  >
>;
export type PatchApiV1EditorCompetitionIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorCompetitionId']
    >
  >
>;
export type DeleteApiV1EditorCompetitionIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorCompetitionId']
    >
  >
>;
export type PostApiV1EditorCountryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorCountry']
    >
  >
>;
export type PatchApiV1EditorCountryIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorCountryId']
    >
  >
>;
export type DeleteApiV1EditorCountryIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorCountryId']
    >
  >
>;
export type PostApiV1EditorPoolResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['postApiV1EditorPool']
    >
  >
>;
export type PatchApiV1EditorPoolIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorPoolId']
    >
  >
>;
export type DeleteApiV1EditorPoolIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorPoolId']
    >
  >
>;
export type PostApiV1EditorPoolCloseSingleResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorPoolCloseSingle']
    >
  >
>;
export type PostApiV1EditorPoolAddEventResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorPoolAddEvent']
    >
  >
>;
export type DeleteApiV1EditorPoolRemoveEventResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorPoolRemoveEvent']
    >
  >
>;
export type PostApiV1EditorEventResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['postApiV1EditorEvent']
    >
  >
>;
export type PostApiV1EditorEventCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorEventCollection']
    >
  >
>;
export type PatchApiV1EditorEventIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorEventId']
    >
  >
>;
export type DeleteApiV1EditorEventIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorEventId']
    >
  >
>;
export type PostApiV1EditorEventImportEventsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorEventImportEvents']
    >
  >
>;
export type GetApiV1EditorGiveawayPlaceRewardsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EditorGiveawayPlaceRewards']
    >
  >
>;
export type PatchApiV1EditorGiveawayPlaceRewardsKindPlaceResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorGiveawayPlaceRewardsKindPlace']
    >
  >
>;
export type PostApiV1EditorInventoryEquipmentResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorInventoryEquipment']
    >
  >
>;
export type PostApiV1EditorInventoryAccessoryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorInventoryAccessory']
    >
  >
>;
export type PostApiV1EditorInventoryUsersUserIdPatchBoxesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorInventoryUsersUserIdPatchBoxes']
    >
  >
>;
export type PostApiV1EditorInventoryUsersUserIdLootBagsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorInventoryUsersUserIdLootBags']
    >
  >
>;
export type GetApiV1EditorInventoryEquipmentRestoreSettingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EditorInventoryEquipmentRestoreSettings']
    >
  >
>;
export type PatchApiV1EditorInventoryEquipmentRestoreSettingsRarityResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['patchApiV1EditorInventoryEquipmentRestoreSettingsRarity']
      >
    >
  >;
export type GetApiV1EditorInventoryLootBagsTicketDropRulesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EditorInventoryLootBagsTicketDropRules']
    >
  >
>;
export type PatchApiV1EditorInventoryLootBagsTicketDropRulesRarityResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['patchApiV1EditorInventoryLootBagsTicketDropRulesRarity']
      >
    >
  >;
export type PostApiV1EditorMediaUploadResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EditorMediaUpload']
    >
  >
>;
export type DeleteApiV1EditorMediaMediaAssetIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorMediaMediaAssetId']
    >
  >
>;
export type PostApiV1EditorTeamResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['postApiV1EditorTeam']
    >
  >
>;
export type PatchApiV1EditorTeamIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorTeamId']
    >
  >
>;
export type DeleteApiV1EditorTeamIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1EditorTeamId']
    >
  >
>;
export type PatchApiV1EditorUserIdBanResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorUserIdBan']
    >
  >
>;
export type PatchApiV1EditorUserIdUnbanResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorUserIdUnban']
    >
  >
>;
export type PatchApiV1EditorWalletUserIdAdjustResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['patchApiV1EditorWalletUserIdAdjust']
    >
  >
>;
export type GetApiV1EventPoolIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1EventPoolId']
    >
  >
>;
export type GetApiV1EventPoolFilterResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EventPoolFilter']
    >
  >
>;
export type GetApiV1EventPoolCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EventPoolCollection']
    >
  >
>;
export type GetApiV1EventPoolDuelMatchesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EventPoolDuelMatches']
    >
  >
>;
export type PostApiV1EventPoolDuelEntryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1EventPoolDuelEntry']
    >
  >
>;
export type GetApiV1EventIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1EventId']
    >
  >
>;
export type GetApiV1EventCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1EventCollection']
    >
  >
>;
export type GetApiV1ForecastSingleResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1ForecastSingle']
    >
  >
>;
export type PostApiV1ForecastSingleResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1ForecastSingle']
    >
  >
>;
export type GetApiV1ForecastDuelResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1ForecastDuel']
    >
  >
>;
export type PostApiV1ForecastDuelResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1ForecastDuel']
    >
  >
>;
export type GetApiV1GiveawaySingleLeaderboardResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1GiveawaySingleLeaderboard']
    >
  >
>;
export type GetApiV1GiveawayCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1GiveawayCollection']
    >
  >
>;
export type GetApiV1GiveawayIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1GiveawayId']
    >
  >
>;
export type GetApiV1InventoryCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryCollection']
    >
  >
>;
export type GetApiV1InventoryFilterResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryFilter']
    >
  >
>;
export type GetApiV1InventoryIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1InventoryId']
    >
  >
>;
export type GetApiV1InventoryOwnPatchBoxesCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryOwnPatchBoxesCollection']
    >
  >
>;
export type PostApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpenResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryOwnPatchBoxesUserPatchBoxIdOpen']
      >
    >
  >;
export type GetApiV1InventoryOwnLootBagsCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryOwnLootBagsCollection']
    >
  >
>;
export type PostApiV1InventoryOwnLootBagsUserLootBagIdOpenResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryOwnLootBagsUserLootBagIdOpen']
    >
  >
>;
export type GetApiV1InventoryOwnEquipmentCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryOwnEquipmentCollection']
    >
  >
>;
export type GetApiV1InventoryOwnAccessoriesCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryOwnAccessoriesCollection']
    >
  >
>;
export type GetApiV1InventoryEquipmentIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryEquipmentId']
    >
  >
>;
export type GetApiV1InventoryAccessoriesIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryAccessoriesId']
    >
  >
>;
export type PostApiV1InventoryEquipmentCrossResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryEquipmentCross']
    >
  >
>;
export type GetApiV1InventoryEquipmentCrossCostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryEquipmentCrossCost']
    >
  >
>;
export type PostApiV1InventoryEquipmentEquipmentIdUpgradeLevelResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryEquipmentEquipmentIdUpgradeLevel']
      >
    >
  >;
export type PostApiV1InventoryEquipmentEquipmentIdRestoreDurabilityResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryEquipmentEquipmentIdRestoreDurability']
      >
    >
  >;
export type PostApiV1InventoryAccessoriesMergeResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryAccessoriesMerge']
    >
  >
>;
export type GetApiV1InventoryAccessoriesMergeCostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryAccessoriesMergeCost']
    >
  >
>;
export type PostApiV1InventoryAccessoriesAccessoryIdEquipEquipmentIdResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryAccessoriesAccessoryIdEquipEquipmentId']
      >
    >
  >;
export type PostApiV1InventoryAccessoriesAccessoryIdUnequipResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryAccessoriesAccessoryIdUnequip']
    >
  >
>;
export type GetApiV1InventoryMarketListingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1InventoryMarketListings']
    >
  >
>;
export type PostApiV1InventoryMarketEquipmentEquipmentIdSellResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryMarketEquipmentEquipmentIdSell']
      >
    >
  >;
export type PostApiV1InventoryMarketAccessoryAccessoryIdSellResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getLeagueOfPredictorsAPIGateway
        >['postApiV1InventoryMarketAccessoryAccessoryIdSell']
      >
    >
  >;
export type PostApiV1InventoryMarketListingsListingIdBuyResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryMarketListingsListingIdBuy']
    >
  >
>;
export type PostApiV1InventoryMarketEquipmentEquipmentIdBuyResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryMarketEquipmentEquipmentIdBuy']
    >
  >
>;
export type PostApiV1InventoryMarketAccessoryAccessoryIdBuyResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1InventoryMarketAccessoryAccessoryIdBuy']
    >
  >
>;
export type DeleteApiV1InventoryMarketListingsListingIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['deleteApiV1InventoryMarketListingsListingId']
    >
  >
>;
export type GetApiV1MediaFilesRelativePathResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1MediaFilesRelativePath']
    >
  >
>;
export type GetApiV1NotificationIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1NotificationId']
    >
  >
>;
export type GetApiV1NotificationCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1NotificationCollection']
    >
  >
>;
export type GetApiV1NotificationUnreadResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1NotificationUnread']
    >
  >
>;
export type GetApiV1ReferralsCurrentResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1ReferralsCurrent']
    >
  >
>;
export type GetApiV1TeamIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1TeamId']
    >
  >
>;
export type GetApiV1TeamCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1TeamCollection']
    >
  >
>;
export type GetApiV1UserIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1UserId']
    >
  >
>;
export type GetApiV1UserCollectionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1UserCollection']
    >
  >
>;
export type GetApiV1UserProfileResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1UserProfile']
    >
  >
>;
export type GetApiV1UserStatisticResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1UserStatistic']
    >
  >
>;
export type GetApiV1UserWalletResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getLeagueOfPredictorsAPIGateway>['getApiV1UserWallet']
    >
  >
>;
export type GetApiV1UserWalletTicketConversionRateResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1UserWalletTicketConversionRate']
    >
  >
>;
export type PostApiV1UserWalletTicketConversionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['postApiV1UserWalletTicketConversions']
    >
  >
>;
export type GetApiV1UserWalletTransactionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getLeagueOfPredictorsAPIGateway
      >['getApiV1UserWalletTransactions']
    >
  >
>;
